// This file is autogenerated by tools/genMaterialLibrary. DO NOT EDIT IT DIRECTLY.
export const LayerConfigIdToName = [
  "Carpet_Texture.Carpet_Texture_Oatmeal",
  "Carpet_Texture.Carpet_Texture_Rawwood",
  "RoofTEMP.RoofTEMP_Black",
  "GAF.GAF_Charcoal",
  "GAF.GAF_WeatheredWood",
  "RoofTEMP.RoofTEMP_Gray",
  "CT_Landmark.CT_Landmark_CharcoalBlack",
  "CT_Landmark.CT_Landmark_Driftwood",
  "CT_Landmark.CT_Landmark_GeorgetownGray",
  "CT_Landmark.CT_Landmark_HeatherBlend",
  "CT_Landmark.CT_Landmark_MoireBlack",
  "CT_Landmark.CT_Landmark_WeatheredWood",
  "RoofTEMP.RoofTEMP_ResawnShake",
  "Roof_StandingSeamIR.Roof_StandingSeamIR_CharcoalGray",
  "Roof_StandingSeamIR.Roof_StandingSeamIR_CoalBlack",
  "Atlas.Atlas_WeatheredWood",
  "RoofTEMP.RoofTEMP_Black",
  "GAF.GAF_Charcoal",
  "GAF.GAF_WeatheredWood",
  "RoofTEMP.RoofTEMP_Gray",
  "CT_Landmark.CT_Landmark_CharcoalBlack",
  "CT_Landmark.CT_Landmark_Driftwood",
  "CT_Landmark.CT_Landmark_GeorgetownGray",
  "CT_Landmark.CT_Landmark_HeatherBlend",
  "CT_Landmark.CT_Landmark_MoireBlack",
  "CT_Landmark.CT_Landmark_WeatheredWood",
  "RoofTEMP.RoofTEMP_ResawnShake",
  "Roof_StandingSeamIR.Roof_StandingSeamIR_CharcoalGray",
  "Roof_StandingSeamIR.Roof_StandingSeamIR_CoalBlack",
  null,
  null,
  null,
  null,
  null,
  "Wood_Trim.Wood_Brown",
  "Wood_Trim.Wood_Cedar",
  "Wood_Trim.Wood_Morado",
  "Wood_Trim.Wood_NaturallyDistressedCharcoal",
  "Wood_Trim.Wood_NaturallyDistressedWhite",
  "Wood_Trim.Wood_Oak",
  "Brick_FAKE.Brick_FAKE_Chalk",
  "Brick_Paint_SW.Brick_SW_7068_GrizzleGray",
  "Brick_Triangle.Brick_Tri_BessemerGray",
  "Brick_Triangle.Brick_Tri_Oxford",
  "Brick_Triangle.Brick_Tri_SouthHampton",
  "Brick_Meridian.Brick_Mer_SaltPlains",
  "Brick_Meridian.Brick_Mer_ShadowFalls",
  "Brick_Meridian.Brick_Mer_SummerAsh",
  "Brick_Cherokee.Brick_Che_Augusta",
  "Brick_Cherokee.Brick_Che_Natchez",
  "Brick_Meridian.Brick_Mer_AlpineSelect",
  "Brick_Triangle.Brick_Tri_EvelynBay",
  "Brick_Triangle.Brick_Tri_MountainBranchSelect",
  "HorizontalBoard.HorizontalBoard_Nichia_Cedar",
  "HorizontalBoard.HorizontalBoard_TimberBlend",
  "HorizontalBoard.HorizontalBoard_White",
  "ShakeShingle.ShakeShingle_Foundry_034_Eggshell",
  "ShakeShingle.ShakeShingle_Foundry_112_Moss",
  "ShakeShingle.ShakeShingle_Gray",
  "ShakeShingle.ShakeShingle_JH_AgedPewter",
  "ShakeShingle.ShakeShingle_JH_BoothbayBlue",
  "ShakeShingle.ShakeShingle_JH_TimberBark",
  null,
  null,
  null,
  "ShakeShingle.ShakeShingle_White",
  "Masonry_Stone_Trim.Masonry_Stone_Centurion_Hackett_Tulsa_Trim",
  "Stone_Centurion_Hackett.Stone_Centurion_Hackett_Tulsa",
  "Stone_Premier.Stone_Premier_Stack_Walnut",
  "Masonry_Stone_Trim.Masonry_Stone_Prostone_Sawgrass_Trim",
  "Masonry_Stone_Trim.Masonry_Stone_Vener_Cobblestone_GreyBlend_Trim",
  "Masonry_Stone.Stone_Vener_Cobblestone_GreyBlend",
  "Masonry_Stone_Trim.Masonry_Stone_Vener_Cobblestone_Lonestar_Trim",
  "Masonry_Stone.Stone_Vener_Cobblestone_Lonestar",
  "VerticalBoard.VerticalBoard_NaturallyDistressedCharcoal",
  "VerticalBoard.VerticalBoard_NaturallyDistressedWhite",
  "VerticalBoard.VerticalBoard_BM_936_MeadowMist",
  "VerticalBoard.VerticalBoard_Nichia_Cedar",
  "Wood_HorizontalPlank.HorizontalPlank_Morado",
  "Wood_HorizontalPlank.HorizontalPlank_Oyster",
  "Wood_HorizontalPlank.HorizontalPlank_SlateGray",
  "Wood_StaggeredPlank.StaggeredPlank_Cherry",
  "Wood_StaggeredPlank.StaggeredPlank_Gunstock",
  "Wood_StaggeredPlank.StaggeredPlank_Tower",
  "VerticalBoard.VerticalBoard_Thermory_Ignite",
  "HorizontalBoard.HorizontalBoard_Thermory_Ignite",
  "VerticalBoard.VerticalBoard_Thermory_Ignite",
  null,
  "CT_Landmark.CT_Landmark_GeorgetownGray_MaxDef",
  "CT_Landmark.CT_Landmark_WeatheredWood_MaxDef",
  "Brick_Meridian.Brick_Mer_Alamo",
  "Brick_Meridian.Brick_Mer_Belhaven",
  "Brick_Meridian.Brick_Mer_Laredo",
  "Brick_Meridian.Brick_Mer_MtRushmore",
  "Brick_Meridian.Brick_Mer_NorthHighland",
  "Brick_Meridian.Brick_Mer_OldGuignard",
  "Brick_Meridian.Brick_Mer_OldJackson",
  "Brick_Meridian.Brick_Mer_Smithsonian",
  "Brick_Meridian.Brick_Mer_StLorain",
  "Brick_Meridian.Brick_Mer_Baytown",
  "Brick_Meridian.Brick_Mer_Dover",
  "Brick_Meridian.Brick_Mer_StAndrews",
  "Vinyl_TrafficMaster.VinylStone_NaturalSlate",
  "Wood_SherwinWilliams_Stains_V.Wood_SW_Stain_3540_MountainAsh_V",
  "Wood_SherwinWilliams_Stains.Wood_SW_Stain_3540_MountainAsh",
  "Brick_Triangle.Brick_Tri_OldColony",
  "Brick_Triangle.Brick_Tri_Northampton",
  "Brick_CasaDaSassi.Brick_CdS_FullBrown",
  "Stone_Environmental.Stone_Env_Dakota",
  "Stone_StoneWorks_CS.Stone_SW_CustomEpcon",
  "Stone_ProVia_TC.Stone_ProVia_Summit",
  "Stone_ProVia_Lime.Stone_ProVia_BlueRidge",
  "Stone_ProVia_TC.Stone_ProVia_Flintridge",
  "Stone_ProVia_TC.Stone_ProVia_Frost",
  "Stone_ProVia_TC.Stone_ProVia_Slate",
  "Stone_ProVia_Trim.Stone_ProVia_BlueRidge_Trim",
  "Stone_ProVia_Trim.Stone_ProVia_Flintridge_Trim",
  "Stone_ProVia_Trim.Stone_ProVia_Frost_Trim",
  "Stone_ProVia_Trim.Stone_ProVia_Slate_Trim",
  "Stone_ProVia_Trim.Stone_ProVia_Summit_Trim",
  "GAF.GAF_BlackWalnut",
  "Tamko.Tamko_NaturalTimber",
  "Tamko.Tamko_OldeEnglishPewter",
  "Tamko.Tamko_ThunderstormGrey",
  "Stone_CulturedStone_Trim.Stone_CS_BucksCounty_Trim",
  "Stone_Cultured_Lime.Stone_Cultured_BucksCounty",
  "Stone_CulturedStone_Trim.Stone_CS_Chardonnay_Trim",
  "Stone_Cultured_Lime.Stone_Cultured_Chardonnay",
  "Stone_Environmental_Trim.Stone_Env_Dakota_Trim",
  "Stone_Environmental_Trim.Stone_Env_EpconCustom_Trim",
  "Stone_Environmental_Trim.Stone_Env_PASierra_Trim",
  "Stone_Environmental.Stone_Env_PASierra",
  "Stone_Environmental_Trim.Stone_Env_Dakota_CustomIN_Trim",
  "Stone_StoneWorks_CS.Stone_SW_CustomINDakota",
  "Brick_Paint_SW.Brick_SW_6246_NorthStar",
  "Brick_Paint_SW.Brick_SW_9171_FeltedWool",
  "Brick_Paint_SW.Brick_SW_9174_MothWing",
  "CT_Belmont.CT_Belmont_BlackGranite",
  "CT_Belmont.CT_Belmont_ColonialSlate",
  "CT_Belmont.CT_Belmont_GatehouseSlate",
  "CT_Belmont.CT_Belmont_Shenandoah",
  "CT_Belmont.CT_Belmont_StonegateGray",
  "CT_Belmont.CT_Belmont_WeatheredWood",
  "CT_CarriageHouse.CT_CarriageHouse_BlackPearl",
  "CT_CarriageHouse.CT_CarriageHouse_Brownstone",
  "CT_CarriageHouse.CT_CarriageHouse_ColonialSlate",
  "CT_CarriageHouse.CT_CarriageHouse_GatehouseSlate",
  "CT_CarriageHouse.CT_CarriageHouse_GeorgianBrick",
  "CT_CarriageHouse.CT_CarriageHouse_SherwoodForest",
  "CT_CarriageHouse.CT_CarriageHouse_StonegateGray",
  "CT_CarriageHouse.CT_CarriageHouse_VictorianBlue",
  "CT_GrandManor.CT_GrandManor_BlackPearl",
  "CT_GrandManor.CT_GrandManor_Brownstone",
  "CT_GrandManor.CT_GrandManor_ColonialSlate",
  "CT_GrandManor.CT_GrandManor_GatehouseSlate",
  "CT_GrandManor.CT_GrandManor_GeorgianBrick",
  "CT_GrandManor.CT_GrandManor_SherwoodForest",
  "CT_GrandManor.CT_GrandManor_StonegateGray",
  "CT_GrandManor.CT_GrandManor_WeatheredWood",
  "CT_HighlandSlate.CT_HighlandSlate_BlackGranite",
  "CT_HighlandSlate.CT_HighlandSlate_Fieldstone",
  "CT_HighlandSlate.CT_HighlandSlate_MaxDef_WeatheredWood",
  "CT_HighlandSlate.CT_HighlandSlate_NewEnglandSlate",
  "CT_HighlandSlate.CT_HighlandSlate_SmokeyQuartz",
  "CT_Landmark_Premium.CT_Landmark_Premium_MaxDef_BurntSienna",
  "CT_Landmark_Premium.CT_Landmark_Premium_MaxDef_ColonialSlate",
  "CT_Landmark_Premium.CT_Landmark_Premium_MaxDef_Driftwood",
  "CT_Landmark_Premium.CT_Landmark_Premium_MaxDef_GeorgetownGray",
  "CT_Landmark_Premium.CT_Landmark_Premium_MaxDef_HeatherBlend",
  "CT_Landmark_Premium.CT_Landmark_Premium_MaxDef_MoireBlack",
  "CT_Landmark_Premium.CT_Landmark_Premium_MaxDef_PewterWood",
  "CT_Landmark_Premium.CT_Landmark_Premium_MaxDef_ResawnShake",
  "CT_Landmark_Premium.CT_Landmark_Premium_MaxDef_WeatheredWood",
  "CT_Landmark_Pro.CT_Landmark_Pro_CinderBlack",
  "CT_Landmark_Pro.CT_Landmark_Pro_GraniteGray",
  "CT_Landmark_Pro.CT_Landmark_Pro_MaxDef_BlackWalnut",
  "CT_Landmark_Pro.CT_Landmark_Pro_MaxDef_BurntSienna",
  "CT_Landmark_Pro.CT_Landmark_Pro_MaxDef_CharcoalBlack",
  "CT_Landmark_Pro.CT_Landmark_Pro_MaxDef_CobblestoneGray",
  "CT_Landmark_Pro.CT_Landmark_Pro_MaxDef_ColonialSlate",
  "CT_Landmark_Pro.CT_Landmark_Pro_MaxDef_Driftwood",
  "CT_Landmark_Pro.CT_Landmark_Pro_MaxDef_GeorgetownGray",
  "CT_Landmark_Pro.CT_Landmark_Pro_MaxDef_HeatherBlend",
  "CT_Landmark_Pro.CT_Landmark_Pro_MaxDef_MoireBlack",
  "CT_Landmark_Pro.CT_Landmark_Pro_MaxDef_MojaveTan",
  "CT_Landmark_Pro.CT_Landmark_Pro_MaxDef_Pewter",
  "CT_Landmark_Pro.CT_Landmark_Pro_MaxDef_PewterWood",
  "CT_Landmark_Pro.CT_Landmark_Pro_MaxDef_PrairieWood",
  "CT_Landmark_Pro.CT_Landmark_Pro_MaxDef_ResawnShake",
  "CT_Landmark_Pro.CT_Landmark_Pro_MaxDef_Shenandoah",
  "CT_Landmark_Pro.CT_Landmark_Pro_MaxDef_SilverBirch",
  "CT_Landmark_Pro.CT_Landmark_Pro_MaxDef_SunriseCedar",
  "CT_Landmark_Pro.CT_Landmark_Pro_MaxDef_WeatheredWood",
  "CT_Landmark_Pro_Solaris.CT_Landmark_Pro_Solaris_BurntSienna",
  "CT_Landmark_Pro_Solaris.CT_Landmark_Pro_Solaris_MaxDef_BurntSienna",
  "CT_Landmark_Pro_Solaris.CT_Landmark_Pro_Solaris_MaxDef_GeorgetownGray",
  "CT_Landmark_Pro_Solaris.CT_Landmark_Pro_Solaris_MaxDef_HeatherBlend",
  "CT_Landmark_Pro_Solaris.CT_Landmark_Pro_Solaris_MaxDef_MoireBlack",
  "CT_Landmark_Pro_Solaris.CT_Landmark_Pro_Solaris_MaxDef_ResawnShake",
  "CT_Landmark_Pro_Solaris.CT_Landmark_Pro_Solaris_MaxDef_WeatheredWood",
  "CT_Landmark_Pro_Solaris.CT_Landmark_Pro_Solaris_SilverBirch",
  "CT_Landmark_Solaris.CT_Landmark_Solaris_AgedCedar",
  "CT_Landmark_Solaris.CT_Landmark_Solaris_Birch",
  "CT_Landmark_Solaris.CT_Landmark_Solaris_BurntSienna",
  "CT_Landmark_Solaris.CT_Landmark_Solaris_CrystalGray",
  "CT_Landmark_Solaris.CT_Landmark_Solaris_GeorgetownGray",
  "CT_Landmark_Solaris.CT_Landmark_Solaris_Graphite",
  "CT_Landmark_Solaris.CT_Landmark_Solaris_HeatherBlend",
  "CT_Landmark_Solaris.CT_Landmark_Solaris_MistWhite",
  "CT_Landmark_Solaris.CT_Landmark_Solaris_MoireBlack",
  "CT_Landmark_Solaris.CT_Landmark_Solaris_MojaveTan",
  "CT_Landmark_Solaris.CT_Landmark_Solaris_ResawnShake",
  "CT_Landmark_Solaris.CT_Landmark_Solaris_SilverBirch",
  "CT_Landmark_Solaris.CT_Landmark_Solaris_WeatheredWood",
  "CT_Landmark_TL.CT_Landmark_TL_BlackWalnut",
  "CT_Landmark_TL.CT_Landmark_TL_CountryGray",
  "CT_Landmark_TL.CT_Landmark_TL_MoireBlack",
  "CT_Landmark_TL.CT_Landmark_TL_Platinum",
  "CT_Landmark_TL.CT_Landmark_TL_Shenandoah",
  "CT_Landmark_TL_Solaris.CT_Landmark_TL_Solaris_CountryGray",
  "CT_Landmark_TL_Solaris.CT_Landmark_TL_Solaris_MoireBlack",
  "CT_Landmark_TL_Solaris.CT_Landmark_TL_Solaris_Platinum",
  "CT_Northgate_Climate_Flex.CT_Northgate_ClimateFlex_MaxDef_BurntSienna",
  "CT_Northgate_Climate_Flex.CT_Northgate_ClimateFlex_MaxDef_Driftwood",
  "CT_Northgate_Climate_Flex.CT_Northgate_ClimateFlex_MaxDef_GeorgetownGray",
  "CT_Northgate_Climate_Flex.CT_Northgate_ClimateFlex_MaxDef_GraniteGray",
  "CT_Northgate_Climate_Flex.CT_Northgate_ClimateFlex_MaxDef_HeatherBlend",
  "CT_Northgate_Climate_Flex.CT_Northgate_ClimateFlex_MaxDef_HunterGreen",
  "CT_Northgate_Climate_Flex.CT_Northgate_ClimateFlex_MaxDef_MoireBlack",
  "CT_Northgate_Climate_Flex.CT_Northgate_ClimateFlex_MaxDef_Pewter",
  "CT_Northgate_Climate_Flex.CT_Northgate_ClimateFlex_MaxDef_ResawnShake",
  "CT_Northgate_Climate_Flex.CT_Northgate_ClimateFlex_MaxDef_SilverBirch",
  "CT_Northgate_Climate_Flex.CT_Northgate_ClimateFlex_MaxDef_WeatheredWood",
  "CT_Landmark.CT_Landmark_BlackWalnut",
  "CT_Landmark.CT_Landmark_BurntSienna",
  "CT_Landmark.CT_Landmark_CinderBlack",
  "CT_Landmark.CT_Landmark_CobblestoneGray",
  "CT_Landmark.CT_Landmark_ColonialSlate",
  "CT_Landmark.CT_Landmark_HunterGreen",
  "CT_Landmark.CT_Landmark_MoireBlack_MaxDef",
  "CT_Landmark.CT_Landmark_MojaveTan",
  "CT_Landmark.CT_Landmark_PaintedDesert",
  "CT_Landmark.CT_Landmark_Pewter",
  "CT_Landmark.CT_Landmark_Pewterwood",
  "CT_Landmark.CT_Landmark_ResawnShake",
  "CT_Landmark.CT_Landmark_SilverBirch",
  "CT_Landmark.CT_Landmark_SunriseCedar",
  "CT_Landmark.CT_Landmark_ThunderstormGray",
  "Wood_HorizontalPlank.HorizontalPlank_Cedar",
  "Brick_Acme.Brick_Acme_AdobeWells",
  "Brick_Acme.Brick_Acme_Frostwood",
  "Brick_Acme.Brick_Acme_ParkShadows",
  "Brick_Acme.Brick_Acme_Silverthorn",
  "Brick_Acme.Brick_Acme_StoneBay",
  "Brick_GlenGery.Brick_GlenGery_AntiqueWhite",
  "Brick_GlenGery.Brick_GlenGery_AztecWhite",
  "Brick_GlenGery.Brick_GlenGery_Birch",
  "Brick_GlenGery.Brick_GlenGery_Casablanca",
  "Brick_GlenGery.Brick_GlenGery_WilliamsburgBradford",
  "Brick_GlenGery.Brick_GlenGery_WilliamsburgCherryCreek",
  "Brick_GlenGery.Brick_GlenGery_WilliamsburgHampton",
  "Brick_RedRiver.Brick_RedRiver_AlpineFog",
  "Brick_RedRiver.Brick_RedRiver_CrescentGrove",
  "Brick_RedRiver.Brick_RedRiver_FireOak",
  "Brick_RedRiver.Brick_RedRiver_Glenwood",
  "Brick_RedRiver.Brick_RedRiver_SaltPlains",
  "Brick_RedRiver.Brick_RedRiver_ShadowFalls",
  "Brick_RedRiver.Brick_RedRiver_ShelteredBluff",
  "Brick_RedRiver.Brick_RedRiver_Tecomate",
  "Wood_Door_PlyGem.Wood_PlyGem_CarbonBlack",
  "Wood_Door_PlyGem.Wood_PlyGem_DarkWalnut",
  "Wood_Door_PlyGem.Wood_PlyGem_Espresso",
  "Wood_Door_PlyGem.Wood_PlyGem_NaturalWalnut",
  "Brick_Lusco.Brick_Lusco_PearlRiver",
  "Brick_RedRiver.Brick_RedRiver_WellsValley",
  "CT_Landmark.CT_Landmark_BlackShadow",
  "Wood_Trim.Wood_Cedar_Beachwood",
  "Wood_Trim.Wood_Cedar_BlackOak",
  "Wood_Trim.Wood_Cedar_DriftwoodGray",
  "Wood_Trim.Wood_Cedar_Ebony",
  "Wood_Trim.Wood_Cedar_Mink",
  "Wood_Trim.Wood_Cedar_Natural",
  "Wood_Trim.Wood_Cedar_Sandstone",
  "Stone_CS_CountryLedgestone_Trim.Stone_CS_CL_BlackRundle_Trim",
  "Stone_Cultured_CL.Stone_Cultured_CL_BlackRundle",
  "Stone_CS_CountryLedgestone_Trim.Stone_CS_CL_GrandMesa_Trim",
  "Stone_Cultured_CL.Stone_Cultured_CL_GrandMesa",
  "Stone_ES_MountainLedge_Trim.Stone_ES_ML_MesaVerde_Trim",
  "Stone_Eldorado_ML.Stone_Eldorado_ML_MesaVerde",
  "Wood_TeddWood_Stains.Wood_NaturalCherry_Alamo",
  "Brick_Meridian.Brick_Mer_ChimneyMountain",
  "Brick_Meridian.Brick_Mer_PortHuron",
  "Tamko.Tamko_RusticBlack",
  "Tamko.Tamko_VirginiaSlate",
  "Brick_Acme.Brick_Acme_Augusta",
  "Brick_Acme.Brick_Acme_HamptonMill",
  "Brick_Acme.Brick_Acme_OysterBay",
  "Brick_Acme.Brick_Acme_PineRidge",
  "Brick_Acme.Brick_Acme_RapidFalls",
  "Brick_Acme.Brick_Acme_Scottsdale",
  "OwensCorning_Supreme.OC_Supreme_WeatheredWood",
  "Wood_ReadySeal_Stains.Wood_RS_Stain_NaturalCedar",
  "Brick_RedRiver.Brick_RedRiver_BurlingtonAntique",
  "Brick_RedRiver.Brick_RedRiver_Caprock",
  "Brick_RedRiver.Brick_RedRiver_CypressSprings",
  "Brick_RedRiver.Brick_RedRiver_Mayfield",
  "Brick_RedRiver.Brick_RedRiver_Ridgemont",
  "Brick_RedRiver.Brick_RedRiver_Silverado",
  "Tamko.Tamko_OxfordGrey",
  "Tamko.Tamko_WeatheredWood",
  "Stone_RockMaterials_RC.Stone_RM_RC_SilvermistChopped",
  "Stone_RockMaterials_Sawn.Stone_RM_Sawn_BlancoChopped",
  "Stone_RockMaterials_Sawn.Stone_RM_Sawn_LuedersChopped",
  "Stone_RockMaterials_SB.Stone_RM_SB_LuedersOnyxChopped",
  "Stone_RockMaterials_SB.Stone_RM_SB_OpalChopped",
  "Stone_RockMaterials_Sawn.Stone_RM_Sawn_TexasMixChopped",
  "Stone_RockMaterials_WS.Stone_RM_WS_WaterfordLimestone",
  "Stone_RM_RoughChopped_Trim.Stone_RM_RoughChopped_SilvermistChopped_Trim",
  "Stone_RM_Sawn_Trim.Stone_RM_Sawn_BlancoChopped_Trim",
  "Stone_RM_Sawn_Trim.Stone_RM_Sawn_LuedersChopped_Trim",
  "Stone_RM_Sawn_Trim.Stone_RM_Sawn_LuedersOnyxChopped_Trim",
  "Stone_RM_Sawn_Trim.Stone_RM_Sawn_OpalChopped_Trim",
  "Stone_RM_Sawn_Trim.Stone_RM_Sawn_TexasMixChopped_Trim",
  "Stone_RM_Sawn_Trim.Stone_RM_Sawn_WaterfordLimestone_Trim",
  "Brick_Paint_SW.Brick_SW_7004_Snowbound",
  "Wood_Minwax_Stains.Wood_GS_Stain_Black1173",
  "Wood_Minwax_Stains.Wood_GS_Stain_Chestnut1176",
  "Wood_Minwax_Stains.Wood_GS_Stain_Coffee1177",
  "Wood_Minwax_Stains.Wood_GS_Stain_Hickory1178",
  "Wood_Minwax_Stains.Wood_GS_Stain_HoneyMaple1179",
  "Wood_Minwax_Stains.Wood_GS_Stain_Mahogany1180",
  "Wood_SherwinWilliams_Stains.Wood_SW_Stain_3507_Riverwood",
  "Wood_SherwinWilliams_Stains.Wood_SW_Stain_3524_Chestnut",
  "CHI_Garage_Wood.CHI_Wood_AccentsCedar",
  "CHI_Garage_Wood.CHI_Wood_AccentsDarkOak",
  "CHI_Garage_Wood.CHI_Wood_AccentsDriftwood",
  "CHI_Garage_Wood.CHI_Wood_AccentsMahogany",
  "CHI_Garage_Wood.CHI_Wood_AccentsWalnut",
  "CHI_Garage_Wood.CHI_Wood_CarbonOak",
  "CHI_Garage_Wood.CHI_Wood_ClassicWoodgrain",
  "CHI_Garage_Wood.CHI_Wood_ModernWoodgrain",
  "CHI_Garage_Wood.CHI_Wood_NaturalOak",
  "OwensCorning_Oakridge.OC_Oakridge_Brownwood",
  "OwensCorning_Oakridge.OC_Oakridge_DesertTan",
  "OwensCorning_Oakridge.OC_Oakridge_Driftwood",
  "OwensCorning_Oakridge.OC_Oakridge_EstateGray",
  "OwensCorning_Oakridge.OC_Oakridge_OnyxBlack",
  "OwensCorning_Oakridge.OC_Oakridge_Teak",
  "OwensCorning_Oakridge.OC_Oakridge_WilliamsburgGray",
  "Stone_CasaDiSassi_Trim.Stone_CDS_BiancoBlend_Trim",
  "Stone_CasaDiSassi_Blend.Stone_CDS_Blend_Bianco",
  "Stone_CasaDiSassi_Trim.Stone_CDS_NiveoVolterra_Trim",
  "Stone_CasaDiSassi_Volterra.Stone_CDS_Volterra_Niveo",
  "Stone_CasaDiSassi_Trim.Stone_CDS_TurinVolterra_Trim",
  "Stone_CasaDiSassi_Volterra.Stone_CDS_Volterra_Turin",
  "Stone_HalquistStone_Trim.Stone_HS_BasswoodGrey_Trim",
  "Stone_Halquist_Ledge.Stone_Halquist_Ledge_BasswoodGrey",
  "Stone_PrestigeStone_Trim.Stone_PS_Bluegrass_Trim",
  "Stone_PrestigeStone_WL.Stone_PS_Bluegrass",
  "Stone_PrestigeStone_Trim.Stone_PS_PortlandMist_Trim",
  "Stone_PrestigeStone_WL.Stone_PS_PortlandMist",
  "Stone_PrestigeStone_Trim.Stone_PS_PortlandSmokeFlatsCarton_Trim",
  "Stone_PrestigeStone_WL.Stone_PS_PortlandSmokeFlatsCarton",
  "CHI_Garage_Wood_V.CHI_Wood_AccentsCedar_V",
  "CHI_Garage_Wood_V.CHI_Wood_AccentsDarkOak_V",
  "CHI_Garage_Wood_V.CHI_Wood_AccentsDriftwood_V",
  "CHI_Garage_Wood_V.CHI_Wood_AccentsMahogany_V",
  "CHI_Garage_Wood_V.CHI_Wood_AccentsWalnut_V",
  "CHI_Garage_Wood_V.CHI_Wood_CarbonOak_V",
  "CHI_Garage_Wood_V.CHI_Wood_ClassicWoodgrain_V",
  "CHI_Garage_Wood_V.CHI_Wood_ModernWoodgrain_V",
  "CHI_Garage_Wood_V.CHI_Wood_NaturalOak_V",
  "Wood_SherwinWilliams_Stains.Wood_SW_Stain_3125_RanchOak",
  "Stone_EdenValders_Trim.Stone_EV_ChiltonMCV_Trim",
  "Stone_EdenValders.Stone_EV_ChiltonMCV",
  "Stone_EdenValders_Trim.Stone_EV_EdenMCV_Trim",
  "Stone_EdenValders.Stone_EV_EdenMCV",
  "Stone_EdenValders_Trim.Stone_EV_OakfieldMCV_Trim",
  "Stone_EdenValders.Stone_EV_OakfieldMCV",
  "Stone_EdenValders_Trim.Stone_EV_Windsor_Trim",
  "Stone_EdenValders.Stone_EV_Windsor",
  "Stone_FondDuLac_Trim.Stone_FDL_GraphiteManor_Trim",
  "Stone_FondDuLac_Biltmore.Stone_FDL_GraphiteManor",
  "Stone_FondDuLac_Trim.Stone_FDL_FondDuLacCountry_Trim",
  "Stone_FondDuLac_Country.Stone_FDL_FondDuLacCountry",
  "Wood_SherwinWilliams_Stains_V.Wood_SW_Stain_3125_RanchOak_V",
  "Wood_SherwinWilliams_Stains_V.Wood_SW_Stain_3507_Riverwood_V",
  "Wood_SherwinWilliams_Stains_V.Wood_SW_Stain_3524_Chestnut_V",
  "Atlas.Atlas_BlackShadow",
  "Brick_RedRiver.Brick_RedRiver_Amarylis",
  "Brick_GeneralShale.Brick_GS_Domino",
  "Brick_GeneralShale.Brick_GS_BourbonTrail",
  "Brick_GeneralShale.Brick_GS_CavalryGray",
  "Brick_GeneralShale.Brick_GS_NolinRiver",
  "Brick_GeneralShale.Brick_GS_SwanCreek",
  "Brick_HenryBrick.Brick_HB_CypressPoint",
  "Wood_Minwax_Stains.Wood_GS_Stain_AgedOak1024",
  "Stone_MGBrickAndStone_Trim.Stone_MG_AustinWhite_Trim",
  "Stone_MGBrickAndStone_AL.Stone_MGBS_AustinWhite",
  "Stone_MGBrickAndStone_Trim.Stone_MG_Charcoal_Trim",
  "Stone_MGBrickAndStone_LL.Stone_MGBS_Charcoal",
  "Stone_MGBrickAndStone_Trim.Stone_MG_PepperedWhite_Trim",
  "Stone_MGBrickAndStone_LSB.Stone_MGBS_PepperedWhite",
  "Stone_MGBrickAndStone_Trim.Stone_MG_Walnut_Trim",
  "Stone_MGBrickAndStone_AL.Stone_MGBS_Walnut",
  "Brick_Claymex.Brick_Claymex_LeMont",
  "Brick_Claymex.Brick_Claymex_Oxford",
  "Brick_Triangle.Brick_Tri_JeffersonPark",
  "Brick_Triangle.Brick_Tri_SeelyTown",
  "IKO.IKO_CharcoalGrey",
  "IKO.IKO_Driftwood",
  "IKO.IKO_DualBlack",
  "IKO.IKO_DualBrown",
  "IKO.IKO_DualGrey",
  "IKO.IKO_EarthtoneCedar",
  "IKO.IKO_HarvardSlate",
  "IKO.IKO_Weatherwood",
  "EagleRoofing.ER3723_AdobeBlend",
  "Stone_Environmental_Trim.Stone_StoneWorks_AppalacianCutStonePA_Trim",
  "Stone_StoneWorks_CS.Stone_SW_CS_AppalachianPA",
  "Brick_Triangle.Brick_Tri_DoverWhite",
  "Stone_DutchQuality_Trim.Stone_DutchQuality_Elkwood_Trim",
  "Stone_DutchQuality_OLD.Stone_DutchQuality_Elkwood",
  "Stone_DutchQuality_Trim.Stone_DutchQuality_Pennsylvania_Trim",
  "Stone_DutchQuality_Ledge.Stone_DQ_Pennsylvania",
  "Stone_CastleHill_Trim.Stone_CH_AutumnBreeze_Trim",
  "Stone_CastleHill_CE.Stone_CH_AutumnBreeze",
  "Stone_CastleHill_Trim.Stone_CH_GlacialBluff_Trim",
  "Stone_CastleHill_CE.Stone_CH_GlacialBluff",
  "Stone_CastleHill_Trim.Stone_CH_OldCastle_Trim",
  "Stone_CastleHill_CE.Stone_CH_OldCastle",
  "Brick_GeneralShale.Brick_GS_Ashview",
  "Brick_GeneralShale.Brick_GS_Winstar",
  "Stone_DiamondPetra_Trim.DiamondPetra_Tontitown_Trim",
  "Stone_DiamondPetra.Stone_DP_Tontitown",
  "Stone_DutchQuality_Trim.Stone_DutchQuality_Columbus_Trim",
  "Stone_DutchQuality_Ledge.Stone_DQ_Columbus",
  "Stone_Environmental_Trim.Stone_Env_KentuckyCutstone_Trim",
  "Stone_Environmental.Stone_Env_CS_Kentucky",
  "Stone_Environmental_Trim.Stone_Env_TexasCutstone_Trim",
  "Stone_Environmental.Stone_Env_CS_Texas",
  "Brick_Acme.Brick_Acme_Brookstone",
  "Brick_Acme.Brick_Acme_MountainBrook",
  "Brick_Acme.Brick_Acme_Rockwell",
  "Stone_Horizon_Trim.Stone_Horizon_Cumberland_Trim",
  "Stone_Horizon_19C.Stone_Horizon_Cumberland",
  "Stone_Horizon_Trim.Stone_Horizon_Hermitage_Trim",
  "Stone_Horizon_19C.Stone_Horizon_Hermitage",
  "Stone_Horizon_Trim.Stone_Horizon_MossyCreek_Trim",
  "Stone_Horizon_19C.Stone_Horizon_MossyCreek",
  "Wood_SherwinWilliams_Stains_V.Wood_SW_Stain_3542_Charwood_V",
  "Wood_SherwinWilliams_Stains.Wood_SW_Stain_3542_Charwood",
  "Brick_Acme.Brick_Acme_GlacierBay",
  "Brick_Acme.Brick_Acme_Highstone",
  "Brick_Acme.Brick_Acme_WhiteRiverRock",
  "Brick_Bilco.Brick_Bilco_Stardust",
  "Wood_SherwinWilliams_Stains.Wood_SW_Stain_3501_Redwood",
  "Wood_SherwinWilliams_Stains.Wood_SW_Stain_3502_MissionWall",
  "Wood_SherwinWilliams_Stains.Wood_SW_Stain_3503_WhiteBirch",
  "Wood_SherwinWilliams_Stains.Wood_SW_Stain_3504_Woodridge",
  "Wood_SherwinWilliams_Stains.Wood_SW_Stain_3505_YankeeBarn",
  "Wood_SherwinWilliams_Stains.Wood_SW_Stain_3508_CoveredBridge",
  "Wood_SherwinWilliams_Stains.Wood_SW_Stain_3509_BajaBeige",
  "Wood_SherwinWilliams_Stains.Wood_SW_Stain_3511_CedarBark",
  "Wood_SherwinWilliams_Stains.Wood_SW_Stain_3512_CiderMill",
  "Wood_SherwinWilliams_Stains.Wood_SW_Stain_3513_SpiceChest",
  "Wood_SherwinWilliams_Stains.Wood_SW_Stain_3518_Hawthorne",
  "Wood_SherwinWilliams_Stains.Wood_SW_Stain_3520_Ficus",
  "Wood_SherwinWilliams_Stains.Wood_SW_Stain_3521_Crossroads",
  "Wood_SherwinWilliams_Stains.Wood_SW_Stain_3522_BanyanBrown",
  "Wood_SherwinWilliams_Stains.Wood_SW_Stain_3530_MossOlive",
  "Wood_SherwinWilliams_Stains.Wood_SW_Stain_3531_BlueShadow",
  "Wood_SherwinWilliams_Stains.Wood_SW_Stain_3532_HillCountry",
  "Wood_SherwinWilliams_Stains.Wood_SW_Stain_3533_Leeward",
  "Wood_SherwinWilliams_Stains.Wood_SW_Stain_3535_Foliage",
  "Wood_SherwinWilliams_Stains.Wood_SW_Stain_3540_MountainAsh",
  "Wood_SherwinWilliams_Stains.Wood_SW_Stain_3541_HarborMist",
  "Wood_SherwinWilliams_Stains_V.Wood_SW_Stain_3501_Redwood_V",
  "Wood_SherwinWilliams_Stains_V.Wood_SW_Stain_3502_MissionWall_V",
  "Wood_SherwinWilliams_Stains_V.Wood_SW_Stain_3503_WhiteBirch_V",
  "Wood_SherwinWilliams_Stains_V.Wood_SW_Stain_3504_Woodridge_V",
  "Wood_SherwinWilliams_Stains_V.Wood_SW_Stain_3505_YankeeBarn_V",
  "Wood_SherwinWilliams_Stains_V.Wood_SW_Stain_3508_CoveredBridge_V",
  "Wood_SherwinWilliams_Stains_V.Wood_SW_Stain_3509_BajaBeige_V",
  "Wood_SherwinWilliams_Stains_V.Wood_SW_Stain_3511_CedarBark_V",
  "Wood_SherwinWilliams_Stains_V.Wood_SW_Stain_3512_CiderMill_V",
  "Wood_SherwinWilliams_Stains_V.Wood_SW_Stain_3513_SpiceChest_V",
  "Wood_SherwinWilliams_Stains_V.Wood_SW_Stain_3518_Hawthorne_V",
  "Wood_SherwinWilliams_Stains_V.Wood_SW_Stain_3520_Ficus_V",
  "Wood_SherwinWilliams_Stains_V.Wood_SW_Stain_3521_Crossroads_V",
  "Wood_SherwinWilliams_Stains_V.Wood_SW_Stain_3522_BanyanBrown_V",
  "Wood_SherwinWilliams_Stains_V.Wood_SW_Stain_3530_MossOlive_V",
  "Wood_SherwinWilliams_Stains_V.Wood_SW_Stain_3531_BlueShadow_V",
  "Wood_SherwinWilliams_Stains_V.Wood_SW_Stain_3532_HillCountry_V",
  "Wood_SherwinWilliams_Stains_V.Wood_SW_Stain_3533_Leeward_V",
  "Wood_SherwinWilliams_Stains_V.Wood_SW_Stain_3535_Foliage_V",
  "Wood_SherwinWilliams_Stains_V.Wood_SW_Stain_3540_MountainAsh_V",
  "Wood_SherwinWilliams_Stains_V.Wood_SW_Stain_3541_HarborMist_V",
  "Stone_Cultured_Lime.Stone_Cultured_Buckeye",
  "Stone_Cultured_SL.Stone_Cultured_SL_Aspen",
  "Stone_Eldorado_CS.Stone_Eldorado_CS_WhiteBark",
  "Stone_Cultured_SL.Stone_Cultured_SL_EchoRidge",
  "Stone_Eldorado_RC.Stone_Eldorado_RC_AutumnLeaf",
  "Stone_Cultured_AL.Stone_Cultured_AL_UmberCreek",
  "Stone_Cultured_CL.Stone_Cultured_CL_Ashfall",
  "Stone_Cultured_CL.Stone_Cultured_CL_WolfCreek",
  "Stone_Eldorado_ML.Stone_Eldorado_ML_Sierra",
  "Stone_Cultured_DSL.Stone_Cultured_DSL_Rubicon",
  "Stone_Cultured_SL.Stone_Cultured_SL_Gray",
  "Stone_Eldorado_EL.Stone_Eldorado_EL_IronMill",
  "Stone_Eldorado_RL.Stone_Eldorado_RL_Clearwater",
  "Stone_CS_AlpineLedgestone_Trim.Stone_CS_AlpineLedgestone_UmberCreek_Trim",
  "Stone_CulturedStone_Trim.Stone_CS_Buckeye_Trim",
  "Stone_CS_CountryLedgestone_Trim.Stone_CS_CL_Ashfall_Trim",
  "Stone_CS_CountryLedgestone_Trim.Stone_CS_CL_WolfCreek_Trim",
  "Stone_CS_DrystackLedgestone_Trim.Stone_CS_DrystackLedgestone_Rubicon_Trim",
  "Stone_CS_SouthernLedgestone_Trim.Stone_CS_SouthernLedgestone_Aspen_Trim",
  "Stone_CS_SouthernLedgestone_Trim.Stone_CS_SouthernLedgestone_EchoRidge_Trim",
  "Stone_CS_SouthernLedgestone_Trim.Stone_CS_SouthernLedgestone_Gray_Trim",
  "Stone_ES_Cliffstone_Trim_OLD.Stone_ES_Cliffstone_WhiteBark_Trim_OLD",
  "Stone_ES_EuropeanLedge_Trim.Stone_ES_EuropeanLedge_IronMill_Trim",
  "Stone_ES_MountainLedge_Trim.Stone_ES_ML_Sierra_Trim",
  "Stone_ES_Roughcut_Trim.Stone_ES_Roughcut_AutumnLeaf_Trim",
  "Stone_ES_RusticLedge_Trim.Stone_ES_RusticLedge_Clearwater_Trim",
  "Stone_DutchQuality_Trim.Stone_DutchQuality_Ashen_Trim",
  "Stone_DutchQuality_OLD.Stone_DutchQuality_Ashen",
  "Stone_DutchQuality_Trim.Stone_DutchQuality_QuailGrey_Trim",
  "Stone_DutchQuality_OLD.Stone_DutchQuality_QuailGrey",
  "Stone_DutchQuality_Trim.Stone_DutchQuality_WinterPoint_Trim",
  "Stone_DutchQuality_OLD.Stone_DutchQuality_WinterPoint",
  "Brick_Acme.Brick_Acme_ForestHills",
  "Brick_Acme.Brick_Acme_SanJose",
  "Brick_Acme.Brick_Acme_Seabrook",
  "Stone_Horizon_Trim.Stone_Horizon_CanyonRidge_Trim",
  "Stone_Horizon_19C.Stone_Horizon_CanyonRidge",
  "Stone_ProVia_EdgeCut_Trim.Stone_ProVia_EdgeCut_Tundra_Trim",
  "Stone_ProVia_EC.Stone_ProVia_EC_Tundra",
  "Stone_ProVia_RidgeCut_Trim.Stone_ProVia_RidgeCut_Silverton_Trim",
  "Stone_ProVia_RC.Stone_ProVia_RC_Silverton",
  "Wood_Minwax_Stains.Wood_Stain_Alluvium417",
  "Wood_Minwax_Stains.Wood_Stain_Carbon409",
  "Wood_Minwax_Stains.Wood_Stain_Greenwood413",
  "Wood_Minwax_Stains.Wood_Stain_Oakwood435",
  "Wood_Minwax_Stains.Wood_Stain_Smokewood407",
  "Wood_Minwax_Stains.Wood_Stain_ToastedBarrell405",
  "Stone_Horizon_Trim.Stone_Horizon_HarborBluff_Trim",
  "Stone_Horizon_19C.Stone_Horizon_HarborBluff",
  "Wood_Minwax_Stains_V.Wood_GS_Stain_AgedOak1024_V",
  "Wood_Minwax_Stains_V.Wood_GS_Stain_Black1173_V",
  "Wood_Minwax_Stains_V.Wood_GS_Stain_Chestnut1176_V",
  "Wood_Minwax_Stains_V.Wood_GS_Stain_Coffee1177_V",
  "Wood_Minwax_Stains_V.Wood_GS_Stain_Hickory1178_V",
  "Wood_Minwax_Stains_V.Wood_GS_Stain_HoneyMaple1179_V",
  "Wood_Minwax_Stains_V.Wood_GS_Stain_Mahogany1180_V",
  "Wood_ReadySeal_Stains_V.Wood_RS_Stain_NaturalCedar_V",
  "Wood_Minwax_Stains_V.Wood_Stain_Alluvium417_V",
  "Wood_Minwax_Stains_V.Wood_Stain_Carbon409_V",
  "Wood_Minwax_Stains_V.Wood_Stain_Greenwood413_V",
  "Wood_Minwax_Stains_V.Wood_Stain_Oakwood435_V",
  "Wood_Minwax_Stains_V.Wood_Stain_Smokewood407_V",
  "Wood_Minwax_Stains_V.Wood_Stain_ToastedBarrell405_V",
  "Paver_Belgard_AppianStone.Paver_Belgard_Napoli",
  "OwensCorning_Oakridge.OC_Oakridge_Peppercorn",
  "Brick_GeneralShale.Brick_GS_BarnsleyTudor",
  "Brick_GeneralShale.Brick_GS_KeenelandElite",
  "Brick_GeneralShale.Brick_GS_ShadowGrey",
  "Brick_USBrick.Brick_US_Blackberry",
  "Brick_GeneralShale.Brick_GS_ManorHouseTudor",
  "Brick_Acme.Brick_Acme_FrenchChateaux",
  "Brick_Acme.Brick_Acme_MochaBrownAntique",
  "Brick_Binsa.Brick_Binsa_AmericanAntique",
  "Brick_Binsa.Brick_Binsa_HillStone",
  "Brick_RedRiver.Brick_RedRiver_GlisteningSprings",
  "Brick_Triangle.Brick_Tri_Porter",
  "Stone_Cobra_TLS.Stone_Cobra_FallBlend",
  "Stone_Cobra_TLS.Stone_Cobra_TexasMix",
  "Stone_Cobra_TLS.Stone_Cobra_White",
  "Stone_Cobra_Trim.Stone_Cobra_FallBlend_Trim",
  "Stone_Cobra_Trim.Stone_Cobra_TexasMix_Trim",
  "Stone_Cobra_Trim.Stone_Cobra_White_Trim",
  "Stone_ProVia_Ledgestone_Trim.Stone_ProVia_Ledgestone_Osage_Trim",
  "Stone_ProVia_Ledge.Stone_ProVia_Ledge_Osage",
  "Stone_ProVia_Limestone_Trim.Stone_ProVia_Limestone_Amherst_Trim",
  "Stone_ProVia_Lime.Stone_ProVia_Lime_Amherst",
  "Brick_GeneralShale.Brick_GS_AlpineSelect",
  "Brick_GeneralShale.Brick_GS_VintagePort",
  "Brick_GeneralShale.Brick_GS_Wynnewood",
  "Stone_ProVia_Ledgestone_Trim.Stone_ProVia_Ledgestone_Rushmore_Trim",
  "Stone_ProVia_Ledge.Stone_ProVia_Ledge_Rushmore",
  "Stone_ProVia_Ledgestone_Trim.Stone_ProVia_Ledgestone_Saginaw_Trim",
  "Stone_ProVia_Ledge.Stone_ProVia_Ledge_Saginaw",
  "Stone_ProVia_Limestone_Trim.Stone_ProVia_Limestone_Allegheny_Trim",
  "Stone_ProVia_Lime.Stone_ProVia_Lime_Allegheny",
  "Brick_GeneralShale.Brick_GS_NewcastleGray",
  "Brick_GeneralShale.Brick_GS_OldEdisto",
  "Wood_SherwinWilliams_Stains_V.Wood_SW_Stain_3561_Cedar_V",
  "Wood_SherwinWilliams_Stains.Wood_SW_Stain_3561_Cedar",
  "Brick_Acme.Brick_Acme_CasaBlanca",
  "Brick_Acme.Brick_Acme_Silvercreek",
  "Brick_Bilco.Brick_Bilco_Everest",
  "Brick_Bilco.Brick_Bilco_GrayMist",
  "Brick_Bilco.Brick_Bilco_Scottsdale",
  "Brick_RedRiver.Brick_RedRiver_FoggyMorning",
  "Brick_RedRiver.Brick_RedRiver_SnowMist",
  "Brick_RedRiver.Brick_RedRiver_WhiteRiverRock",
  "Wood_SherwinWilliams_Stains_V.Wood_SW_Stain_3025_Caribou_V",
  "Wood_SherwinWilliams_Stains.Wood_SW_Stain_3025_Caribou",
  "Brick_Acme.Brick_Acme_Callisburg",
  "Brick_Acme.Brick_Acme_CameronHills",
  "Brick_Acme.Brick_Acme_DentonAntique",
  "Brick_Acme.Brick_Acme_OldFrancisco",
  "Brick_Acme.Brick_Acme_Winterstone",
  "Wood_Pella_V.Pella_Wood_Black_V",
  "Wood_Pella.Pella_Wood_Black",
  "Wood_Pella_V.Pella_Wood_Charcoal_V",
  "Wood_Pella.Pella_Wood_Charcoal",
  "Wood_Pella_V.Pella_Wood_DarkMahogany_V",
  "Wood_Pella.Pella_Wood_DarkMahogany",
  "Wood_Pella_V.Pella_Wood_EarlyAmerican_V",
  "Wood_Pella.Pella_Wood_EarlyAmerican",
  "Wood_Pella_V.Pella_Wood_Espresso_V",
  "Wood_Pella.Pella_Wood_Espresso",
  "Wood_Pella_V.Pella_Wood_GoldenOak_V",
  "Wood_Pella.Pella_Wood_GoldenOak",
  "Wood_Pella_V.Pella_Wood_Natural_V",
  "Wood_Pella.Pella_Wood_Natural",
  "Wood_Pella_V.Pella_Wood_Provincial_V",
  "Wood_Pella.Pella_Wood_Provincial",
  "Wood_Pella_V.Pella_Wood_RedMahogany_V",
  "Wood_Pella.Pella_Wood_RedMahogany",
  "Brick_GeneralShale.Brick_GS_SpanishMoss",
  "Brick_Triangle.Brick_Tri_FortMill",
  "Brick_Triangle.Brick_Tri_LibbyMill",
  "Brick_GeneralShale.Brick_GS_CapersIsland",
  "Brick_GeneralShale.Brick_GS_StoneMountain",
  "Brick_GeneralShale.Brick_GS_HeritageTrail",
  "Stone_Cultured_CL.Stone_Cultured_CL_EchoRidge",
  "Stone_Cultured_CL.Stone_Cultured_CL_Gunnison",
  "Stone_Cultured_CL.Stone_Cultured_CL_Wheaton",
  "Stone_DutchQuality_RA.Stone_RA_DQ_WinterPoint",
  "Stone_CS_CountryLedgestone_Trim.Stone_CS_CL_EchoRidge_Trim",
  "Stone_CS_CountryLedgestone_Trim.Stone_CS_CL_Gunnison_Trim",
  "Stone_CS_CountryLedgestone_Trim.Stone_CS_CL_Wheaton_Trim",
  "Stone_RA_DutchQuality_Trim.Stone_RA_DQ_WinterPoint_Trim",
  "CT_Landmark.CT_Landmark_SlateGray",
  "Stone_Samasonry_Chopped.Stone_ROCKCWPLT_ChoppedWhite",
  "Stone_Samasonry_Chopped_Trim.Stone_ROCKCWPLT_ChoppedWhite_Trim",
  "Brick_Claymex.Brick_Claymex_Alpine",
  "Brick_Claymex.Brick_Claymex_Brownfield",
  "Brick_Claymex.Brick_Claymex_Cobblestone",
  "Brick_Claymex.Brick_Claymex_Keystone",
  "Wood_SherwinWilliams_Stains_V.Wood_SW_Stain_3027_Driftwood_V",
  "Wood_SherwinWilliams_Stains.Wood_SW_Stain_3027_Driftwood",
  "Brick_Claymex.Brick_Claymex_Onyx",
  "Brick_Claymex.Brick_Claymex_Pewter",
  "Brick_Claymex.Brick_Claymex_Woodcreek",
  "Brick_Claymex.Brick_Claymex_York",
  "Stone_Samasonry_Chopped_Trim.Stone_ROCKBLUE_ChoppedBlueLueders_Trim",
  "Stone_Samasonry_Chopped.Stone_ROCKBLUE_ChoppedBlueLueders",
  "Stone_Samasonry_Chopped_Trim.Stone_ROCKCCAVE_ChoppedCaveRegular_Trim",
  "Stone_Samasonry_Chopped.Stone_ROCKCCAVE_ChoppedCaveRegular",
  "Wood_SherwinWilliams_Stains_V.Wood_SW_Stain_DB2317_Fig_V",
  "Wood_SherwinWilliams_Stains.Wood_SW_Stain_DB2317_Fig",
  "Wood_SherwinWilliams_Stains_V.Wood_SW_Stain_3566_DouglasFir_V",
  "Wood_SherwinWilliams_Stains.Wood_SW_Stain_3566_DouglasFir",
  "Brick_PGH.Brick_PGH_Bark",
  "Brick_PGH.Brick_PGH_CharacterPutty",
  "Brick_PGH.Brick_PGH_CharacterRedRock",
  "Brick_Harristone.Brick_Harristone_Charleston",
  "Brick_Harristone.Brick_Harristone_DoveGrey",
  "Brick_Harristone.Brick_Harristone_WhiteSand",
  "Stone_Harristone_Trim.Stone_Harristone_Chocolate_Trim",
  "Stone_Harristone_Trim.Stone_Harristone_Cream_Trim",
  "Stone_Harristone_Trim.Stone_Harristone_Grey_Trim",
  "Stone_Harristone_Trim.Stone_Harristone_Tan_Trim",
  "Stone_Harristone_Trim.Stone_Harristone_Taupe_Trim",
  "Stone_Harristone_Div.Stone_Harristone_Div_Huntington",
  "Stone_Harristone_Div.Stone_Harristone_Div_SilverStrand",
  "Stone_Harristone_Div.Stone_Harristone_Div_WhiteSand",
  "Stone_Harristone_DS.Stone_Harristone_DS_Highland",
  "Stone_Harristone_DS.Stone_Harristone_DS_Kingstown",
  "Stone_Harristone_DS.Stone_Harristone_DS_Slate",
  "Stone_Harristone_DS.Stone_Harristone_DS_Stirling",
  "Stone_Harristone_Leuders.Stone_Harristone_Lueders_FlintHills",
  "Stone_Harristone_LS.Stone_Harristone_LS_FlintHills",
  "Stone_Harristone_Tumbled.Stone_Harristone_Tumbled_AustinWhite",
  "Stone_Harristone_Tumbled.Stone_Harristone_Tumbled_Sunlit",
  "Stone_Harristone_Uintah.Stone_HarristoneUintah_Midnight",
  "Stone_Harristone_Uintah.Stone_HarristoneUintah_RockyCliff",
  "Stone_Harristone_Uintah.Stone_Harristone_Uintah_Slate",
  "Stone_Harristone_Trim.Stone_Harristone_WhiteSand_Trim",
  "Stone_Harristone_Trim.Stone_Harristone_Charcoal_Trim",
  "Stone_JNStone_Pioneer.Stone_Pioneer_Belgrade",
  "Stone_JNStone_Pioneer.Stone_Pioneer_Sedona",
  "Stone_Bello_Cobblestone_Trim.Masonry_Stone_Bello_Cobblestone_NewEngland_Trim",
  "Stone_Bello_Cob.Stone_Bello_Cob_NewEngland",
  "Stone_Bello_Cobblestone_Trim.Masonry_Stone_Bello_Cobblestone_Pequea_Trim",
  "Stone_Bello_Cob.Stone_Bello_Cob_Pequea",
  "Stone_Centurion_Old_Trim.Stone_Centurion_Old_NorrisGray_Trim",
  "Stone_Centurion_Old.Stone_Centurion_Old_NorrisGray",
  "Stone_ProVia_ChiselCut_Trim.Stone_ProVia_ChiselCut_Brindle_Trim",
  "Stone_ProVia_CC.Stone_ProVia_CC_Brindle",
  "Stone_ProVia_ChiselCut_Trim.Stone_ProVia_ChiselCut_Silverlake_Trim",
  "Stone_ProVia_CC.Stone_ProVia_CC_Silverlake",
  "Stone_ProVia_DryStack_Trim.Stone_ProVia_DryStack_Pearl_Trim",
  "Stone_ProVia_DS.Stone_ProVia_DS_Pearl",
  "Stone_RM_Sawn_Trim.Stone_RM_Sawn_CafeBlend_Trim",
  "Stone_RockMaterials_Sawn.Stone_RM_Sawn_CafeBlend",
  "Stone_RM_Sawn_Trim.Stone_RM_Sawn_GraphiteFawnBlend_Trim",
  "Stone_RockMaterials_SB.Stone_RM_SB_GraphiteFawnBlend",
  "Brick_Bilco.Brick_Bilco_Camel",
  "Brick_Bilco.Brick_Bilco_Graystone",
  "Brick_Bilco.Brick_Bilco_Onyx",
  "Brick_Bilco.Brick_Bilco_Phoenix",
  "Stone_ProVia_NaturalCut_Trim.Stone_ProVia_NaturalCut_Ashworth_Trim",
  "Stone_ProVia_NC.Stone_ProVia_NC_Ashworth",
  "Stone_ProVia_PrecisionFit_Trim.Stone_ProVia_PrecisionFit_AdobeSands_Trim",
  "Stone_ProVia_PF.Stone_ProVia_PF_AdobeSands",
  "Stone_ProVia_PrecisionFit_Trim.Stone_ProVia_PrecisionFit_Driftwood_Trim",
  "Stone_ProVia_PF.Stone_ProVia_PF_Driftwood",
  "Brick_ProVia.Brick_ProVia_Boston",
  "Brick_ProVia.Brick_ProVia_Cobblestone",
  "Brick_ProVia.Brick_ProVia_Delaware",
  "Brick_ProVia.Brick_ProVia_Midnight",
  "Brick_Heritage.Brick_Heritage_Ashwood",
  "Stone_Bello_Ledgestone_Trim.Stone_Bello_Brecknock_Trim",
  "Stone_Bello_Ledgestone_OLD.Stone_Bello_Brecknock_OLD",
  "Brick_GeneralShale.Brick_GS_Cortez",
  "Brick_USBrick.Brick_US_Monaco",
  "Brick_GeneralShale.Brick_GS_BradfordHall",
  "Stone_QualityStone_DS.Stone_QS_DS_Susquehanna",
  "Stone_QualityStone_Cob.Stone_QS_Cob_PALime",
  "Stone_QualityStone_FS.Stone_QS_FS_LebanonLime",
  "Stone_QualityStone_Cob.Stone_QS_Cob_Conestoga",
  "Stone_QualityStone_Cob.Stone_QS_Cob_Eggshell",
  "Stone_QualityStone_Cob.Stone_QS_Cob_Rockvale",
  "Stone_QualityStone_DS.Stone_QS_DS_Pumice",
  "Stone_QualityStone_FS.Stone_QS_FS_NewEngland",
  "Stone_QualityStone_Cobblestone_Trim.Stone_QS_Cobblestone_Conestoga_Trim",
  "Stone_QualityStone_Cobblestone_Trim.Stone_QS_Cobblestone_Eggshell_Trim",
  "Stone_QualityStone_Cobblestone_Trim.Stone_QS_Cobblestone_PALime_Trim",
  "Stone_QualityStone_Cobblestone_Trim.Stone_QS_Cobblestone_Rockvale_Trim",
  "Stone_QualityStone_Drystack_Trim.Stone_QS_Drystack_Pumice_Trim",
  "Stone_QualityStone_Drystack_Trim.Stone_QS_Drystack_Susquehanna_Trim",
  "Stone_QualityStone_Fieldstone_Trim.Stone_QS_Fieldstone_LebanonLime_Trim",
  "Stone_QualityStone_Fieldstone_Trim.Stone_QS_Fieldstone_NewEngland_Trim",
  "Brick_GeneralShale.Brick_GS_Graymoor",
  "Brick_Triangle.Brick_Tri_CapeFear",
  "Brick_GeneralShale.Brick_GS_ClaytonFalls",
  "GAF.GAF_PewterGray",
  "Brick_GeneralShale.Brick_GS_RedColonial",
  "Brick_Triangle.Brick_Tri_Nantucket",
  "Stone_DutchQuality_StackLedge_Trim.Stone_DQ_StackLedge_Fallbrook_Trim",
  "Stone_DutchQuality_SL.Stone_DQ_SL_Fallbrook",
  "Brick_USBrick.Brick_US_OldJackson",
  "Brick_GeneralShale.Brick_GS_Valor",
  "Patio_Stone_IrwinStone.Patio_Irwin_PennsylvaniaFullColor",
  "Stone_IrwinStone_FS.Stone_Irwin_FS_Andover",
  "Stone_IrwinStone_FS.Stone_Irwin_FS_ChocolateGray",
  "Stone_IrwinStone_FS.Stone_Irwin_FS_DoveGray",
  "Stone_IrwinStone_FS.Stone_Irwin_FS_WesternMaryland",
  "Brick_Acme.Brick_Acme_AnsleyPark",
  "Brick_Acme.Brick_Acme_Menawa",
  "Brick_Acme.Brick_Acme_MushroomBrown",
  "Brick_Acme.Brick_Acme_Texas",
  "OwensCorning_Oakridge.OC_Oakridge_SierraGray",
  "Stone_MountainView_Trim.Stone_MV_Adaline_Trim",
  "Stone_MountainView_Lime.Stone_MV_Adaline",
  "Stone_MountainView_Trim.Stone_MV_Appalachian_Trim",
  "Stone_MountainView_Ledge.Stone_MV_Appalachian",
  "Stone_MountainView_Trim.Stone_MV_BlackForest_Trim",
  "Stone_MountainView_SS.Stone_MV_BlackForest",
  "Stone_MountainView_Trim.Stone_MV_Tuscany_Trim",
  "Stone_MountainView_Lime.Stone_MV_Tuscany",
  "LS_Custom_DualColor.LS_JH_ArcticWhite_Cobblestone",
  "LS_Custom_DualColor.LS_JH_TimberBark_ArcticWhite",
  "LS_Custom_DualColor.LS_JH_TimberBark_RichEspresso",
  "Stone_Eldorado_SS.Stone_Eldorado_SS_Nantucket",
  "Stone_Eldorado_SS.Stone_Eldorado_SS_ChapelHill",
  "Stone_Centurion_Stack.Stone_Centurion_Stack_Coastal",
  "Stone_Centurion_Stack.Stone_Centurion_GrayStainless",
  "Stone_Centurion_Stack.Stone_Centurion_NorrisGray",
  "Stone_Centurion_Stack.Stone_Centurion_Texas",
  "Stone_Centurion_Rubble.Stone_Centurion_Rubble_Tulsa",
  "Brick_Triangle.Brick_Tri_FederalHill",
  "Brick_Triangle.Brick_Tri_Portsmouth",
  "Brick_Triangle.Brick_Tri_RiverStreet",
  "Brick_Triangle.Brick_Tri_Wilmington",
  "Stone_CasaDiSassi_Blend.Stone_CDS_Bella",
  "Stone_CasaDiSassi_Ledge.Stone_CDS_Carbone",
  "Stone_CasaDiSassi_Ledge.Stone_CDS_Gola",
  "Stone_CasaDiSassi_Ledge.Stone_CDS_Matera",
  "Stone_CasaDiSassi_Ledge.Stone_CDS_Niveo",
  "Stone_CasaDiSassi_CR.Stone_CDS_Turin",
  "Stone_CasaDiSassi_Blend.Stone_CDS_Terracina",
  "Stone_CasaDiSassi_Trim.Stone_CDS_Trim_Cream",
  "Stone_CasaDiSassi_Trim.Stone_CDS_Trim_Fumo",
  "Stone_CasaDiSassi_Trim.Stone_CDS_Trim_Mezzo",
  "Stone_CasaDiSassi_Trim.Stone_CDS_Trim_Sage",
  "Stone_CasaDiSassi_Trim.Stone_CDS_Trim_Terra",
  "LS_Custom_DualColor.LS_JH_AgedPewter_ArcticWhite",
  "LS_Custom_DualColor.LS_JH_MontereyTaupe_ArcticWhite",
  "Stone_DutchQuality_SL.Stone_DQ_SL_Torino",
  "Stone_DutchQuality_StackLedge_Trim.Stone_DQ_StackLedge_Torino_Trim",
  "Stone_DutchQuality_Trim.Stone_DutchQuality_Sagewood_Trim",
  "Stone_DutchQuality_Ledge.Stone_DQ_Sagewood",
  "Stone_DutchQuality_StackLedge_Trim.Stone_DQ_StackLedge_Steinhaus_Trim",
  "Stone_DutchQuality_SL.Stone_DQ_SL_Steinhaus",
  "Brick_Triangle.Brick_Tri_ChesapeakeGrey",
  "Brick_Acme.Brick_Acme_OldTavern",
  "Brick_PVStone.Brick_PVStone_Colonial",
  "Brick_PVStone.Brick_PVStone_Neptune",
  "Stone_PremierVeneer_Ledge.Stone_PVStone_Dune",
  "Stone_PremierVeneer_WL.Stone_PVStone_Havana",
  "Stone_PremierVeneer_Ledge.Stone_PVStone_Havasupai",
  "Stone_PremierVeneer_WL.Stone_PVStone_Jurasic",
  "Stone_PremierVeneer_WL.Stone_PVStone_Lermara",
  "Stone_PremierVeneer_Ledge.Stone_PVStone_Mahogany",
  "Brick_Binsa.Brick_Binsa_EnglishDove",
  "Brick_Claymex.Brick_Claymex_Aspen",
  "Stone_RM_Trim.Stone_RM_Bluebonnet_Trim",
  "Stone_RockMaterials_SB.Stone_RM_SB_BlancoChopped",
  "Stone_RockMaterials_Sawn.Stone_RM_Sawn_LuedersBuff",
  "Stone_RockMaterials_Sawn.Stone_RM_LuedersCharcoal",
  "Tamko.Tamko_AntiqueSlate",
  "Tamko.Tamko_RusticSlate",
  "Brick_Triangle.Brick_Tri_Oakton",
  "Brick_USBrick.Brick_US_OldWaverly",
  "Stone_DutchQuality_StackLedge_Trim.Stone_DQ_StackLedge_Sienna_Trim",
  "Stone_DutchQuality_SL.Stone_DQ_SL_Sienna",
  "Stone_Horizon_Trim.Stone_Horizon_Hickory_Trim",
  "Stone_Horizon_19C.Stone_Horizon_Hickory",
  "Stone_Horizon_Trim.Stone_Horizon_SmokyMountain_Trim",
  "Stone_Horizon_19C.Stone_Horizon_SmokyMountain",
  "Stone_Lurveys_Cob.Stone_Lurveys_Cob_Champagne",
  "Stone_Versetta_Trim.Stone_Versetta_Charcoal_Trim",
  "Stone_Versetta.Stone_Versetta_GranitePeak",
  "Stone_Versetta.Stone_Versetta_NorthernAsh",
  "Stone_Versetta.Stone_Versetta_PlumCreek",
  "Stone_Versetta.Stone_Versetta_Sterling",
  "Stone_Versetta_Trim.Stone_Versetta_StoneGrey_Trim",
  "Stone_Versetta_Trim.Stone_Versetta_Taupe_Trim",
  "Stone_Lurveys_Cob.Stone_Lurveys_Cob_GraphiteManor",
  "Brick_Cherokee.Brick_Che_Magnolia",
  "Brick_Acme.Brick_Acme_AdenBlend",
  "Brick_Acme.Brick_Acme_Abbeville",
  "Malarkey.Malarkey_MidnightBlack",
  "Malarkey.Malarkey_NaturalWood",
  "Malarkey.Malarkey_Silverwood",
  "Stone_StoneCraft_Ledge.Stone_StoneCraft_Chardonnay",
  "Stone_CS_CountryLedgestone_Trim.Stone_CS_CL_BucksCounty_Trim",
  "Stone_Cultured_CL.Stone_Cultured_CL_BucksCounty",
  "Stone_DutchQuality_Trim.Stone_DutchQuality_NaturalBlend_Trim",
  "Stone_DutchQuality_OLD.Stone_DutchQuality_NaturalBlend",
  "Stone_DutchQuality_Trim.Stone_DutchQuality_Sienna_Trim",
  "Stone_DutchQuality_OLD.Stone_DutchQuality_Sienna",
  "Stone_QualityStone_Drystack_Trim.Stone_QS_Drystack_Arizona_Trim",
  "Stone_QualityStone_DS.Stone_QS_DS_Arizona",
  "Stone_RA_DutchQuality_Trim.Stone_RA_DQ_Greystone_Trim",
  "Stone_DutchQuality_RA.Stone_RA_DQ_Greystone",
  "Stone_BrandCo_DS.Stone_BrandCo_Erie",
  "Stone_BrandCo_Ledge.Stone_BrandCo_Southbriar",
  "Stone_DutchQuality_Ledge.Stone_DQ_QuailGrey",
  "Stone_Realstone_Trim.Stone_RS_Trim_IndianaLimestoneGrey",
  "Brick_PrestigeStone.Brick_PS_Farmhouse",
  "Stone_PrestigeStone_WL.Stone_PS_Blanc",
  "Stone_PrestigeStone_WL.Stone_PS_Charcoal",
  "Stone_PrestigeStone_WL.Stone_PS_Harvest",
  "Stone_PrestigeStone_WL.Stone_PS_JacksonCreek",
  "Stone_PrestigeStone_OCL.Stone_PS_MoonlitForest",
  "Stone_PrestigeStone_WL.Stone_PS_WhiteOnyx",
  "Brick_USBrick.Brick_US_Magnolia",
  "Brick_USBrick.Brick_US_NatchezTrace",
  "Brick_USBrick.Brick_US_OysterCove",
  "Brick_USBrick.Brick_US_ShadowStone",
  "Brick_USBrick.Brick_US_TimberWood",
  "Stone_DutchQuality_Trim.Stone_DutchQuality_Arizona_Trim",
  "Stone_DutchQuality_DS.Stone_DQ_DS_Arizona",
  "Wood_TimberTech.TT_MaritimeGray",
  "Brick_Acme.Brick_Acme_AuburnHills",
  "Stone_StoneWorks_FS.Stone_SW_FS_Chardonnay",
  "Brick_Acme.Brick_Acme_Saltgrass",
  "Brick_Acme.Brick_Acme_SummerSage",
  "Brick_CommercialBrickCompany.Brick_CBC_ChandlerWhite",
  "Brick_CommercialBrickCompany.Brick_CBC_Hollister",
  "Brick_RedRiver.Brick_RedRiver_FlintRanch",
  "Brick_RedRiver.Brick_RedRiver_OzarkSmoke",
  "Stone_MetroBrick_Limestone.Stone_MetroBrick_AustinCreme",
  "Brick_Acme.Brick_Acme_Shenandoah",
  "Brick_Acme.Brick_Acme_SpanishBay",
  "Brick_Acme.Brick_Acme_WhiteBluff",
  "Brick_Ryder.Brick_Ryder_AntiqueWhite",
  "Brick_Ryder.Brick_Ryder_Casablanca",
  "Brick_Acme.Brick_Acme_ArcticMist",
  "Brick_Acme.Brick_Acme_Inverness",
  "Wood_PPGstains.PPG_Wood_BlackOak",
  "Wood_PPGstains.PPG_Wood_DriftwoodGray",
  "Wood_PPGstains.PPG_Wood_Ebony",
  "Stone_Centurion_Trim.Stone_Centurion_GrayRubble_Trim",
  "Stone_Centurion_Rubble.Stone_Centurion_Rubble_Gray",
  "Stone_Eldorado_Trim.Stone_Eldorado_Trim_Buckskin",
  "Stone_Eldorado_Trim.Stone_Eldorado_Trim_Earth",
  "Stone_Eldorado_Trim.Stone_Eldorado_Trim_Smoke",
  "Stone_Eldorado_Trim.Stone_Eldorado_Trim_Taupe",
  "Stone_Eldorado_BS.Stone_Eldorado_BS_Prescott",
  "Stone_Eldorado_SS.Stone_Eldorado_SS_BlackRiver",
  "Stone_Eldorado_RT.Stone_Eldorado_RT_WhisperWhite",
  "RoofTile_Westlake.RoofTile_Westlake_BlackCanyon",
  "Stone_Bello_Ledge.Stone_Bello_Ledge_Brecknock",
  "Stone_Bello_Ledge.Stone_Bello_Ledge_FultonLime",
  "Stone_Bello_Ledge.Stone_Bello_Ledge_Greenwood",
  "Stone_Bello_Ledge.Stone_Bello_Ledge_Pequea",
  "Stone_Bello_FS.Stone_Bello_FS_Hickory",
  "Brick_TexasStone.Brick_TexasStone_DarkGrayLuxbrick",
  "Brick_TexasStone.Brick_TexasStone_OldTownLux",
  "Brick_Acme.Brick_Acme_GlacierWhite",
  "Brick_Belden.Brick_Belden_BlackDiamondVelour",
  "Brick_Belden.Brick_Belden_GraphiteVelour",
  "Brick_Spaulding.Brick_Spaulding_YankeeHill",
  "Brick_GeneralShale.Brick_GS_Graysburg",
  "Brick_GeneralShale.Brick_GS_MorningSmoke",
  "Brick_GeneralShale.Brick_GS_OldEnglishTutor",
  "GAF.GAF_Barkwood",
  "GAF.GAF_MissionBrown",
  "Stone_StoneWorks_Ledge.Stone_SW_Buckeye",
  "Stone_StoneWorks_Ledge.Stone_SW_Carolina",
  "Stone_StoneWorks_Ledge.Stone_SW_Dakota",
  "Stone_StoneWorks_Ledge.Stone_SW_GreyDrift",
  "Stone_StoneWorks_Ledge.Stone_SW_PASierra",
  "Stone_StoneWorks_CS.Stone_SW_SanFrancisco",
  "Stone_StoneWorks_Trim.Stone_StoneWorks_Buckeye_Trim",
  "Stone_StoneWorks_Trim.Stone_StoneWorks_Carolina_Trim",
  "Stone_StoneWorks_Trim.Stone_StoneWorks_Dakota_Trim",
  "Stone_StoneWorks_Trim.Stone_StoneWorks_GreyDrift_Trim",
  "Stone_StoneWorks_Trim.Stone_StoneWorks_PASierra_Trim",
  "Stone_StoneWorks_Trim.Stone_StoneWorks_SanFrancisco_Trim",
  "Brick_GeneralShale.Brick_GS_ModenaPaver",
  "Stone_Ecostone_Trim.Stone_Ecostone_Moraine_Trim",
  "Stone_Ecostone_RS.Stone_Ecostone_Moraine",
  "Stone_Ecostone_Trim.Stone_Ecostone_WhiteWashed_Trim",
  "Stone_Ecostone_CR.Stone_Ecostone_WhiteWashed",
  "Stone_Eldorado_Trim_OLD.Stone_Eldorado_Andante_Trim",
  "Stone_Eldorado_FL.Stone_Eldorado_FL_Andante",
  "Stone_Eldorado_Trim_OLD.Stone_Eldorado_ChapelHill_Trim",
  "Stone_Eldorado_Trim_OLD.Stone_Eldorado_Ironside_Trim",
  "Stone_Eldorado_TB.Stone_Eldorado_TB_Ironside",
  "Stone_Eldorado_Trim_OLD.Stone_Eldorado_Nantucket_Trim",
  "Stone_PlyGem_Trim.Stone_PlyGem_Charcoal_Trim",
  "Stone_PlyGem_Trim.Stone_PlyGem_Hampton_Trim",
  "Stone_PlyGem_FS.Stone_PlyGem_Hampton",
  "Stone_PlyGem_Trim.Stone_PlyGem_Trim_Lime",
  "Stone_PlyGem_Trim.Stone_PlyGem_Mystic_Trim",
  "Stone_PlyGem_CanyonL.Stone_PlyGem_Mystic",
  "Stone_PlyGem_Trim.Stone_PlyGem_Oswego_Trim",
  "Stone_PlyGem_Manorstone.Stone_PlyGem_Oswego",
  "Stone_PlyGem_Trim.Stone_PlyGem_SandyCreek_Trim",
  "Stone_PlyGem_CascadeL.Stone_PlyGem_CasL_SandyCreek",
  "Wood_Minwax_Stains.Wood_Minwax_Stain_Walnut",
  "Wood_Minwax_Stains_V.Wood_Minwax_Stain_Walnut_V",
  "Patio_Stone_IrwinStone.Patio_Irwin_PABlueFlagstone",
  "Brick_GeneralShale.Brick_GS_Winterhaven",
  "Brick_USBrick.Brick_US_Alamo",
  "Brick_USBrick.Brick_US_AspenChase",
  "Brick_USBrick.Brick_US_Belhaven",
  "Brick_USBrick.Brick_US_BelleMeade",
  "Brick_USBrick.Brick_US_MtRushmore",
  "Brick_USBrick.Brick_US_Newcastle",
  "Brick_USBrick.Brick_US_NorthHighland",
  "Brick_USBrick.Brick_US_OldOverton",
  "Brick_USBrick.Brick_US_StLorain",
  "Stone_BoulderCreek_Trim.Stone_BC_SpanishWheat_Trim",
  "Stone_BoulderCreek_Sangria.Stone_BC_SpanishWheat",
  "Stone_Centurion_Trim.Stone_Centurion_Coastal_Trim",
  "Stone_Centurion_Trim.Stone_Centurion_GrayStainless_Trim",
  "Stone_Centurion_Trim.Stone_Centurion_Kentucky_Trim",
  "Stone_Centurion_Trim.Stone_Centurion_NorrisGray_Trim",
  "Stone_Centurion_Trim.Stone_Centurion_Texas_Trim",
  "Stone_Centurion_Trim.Stone_Centurion_Tulsa_Trim",
  "Stone_DutchQuality_Trim.Stone_DutchQuality_GreatLakes_Trim",
  "Stone_DutchQuality_Lime.Stone_DQ_Lime_GreatLakes",
  "Stone_DutchQuality_Trim.Stone_DutchQuality_OakBlend_Trim",
  "Stone_DutchQuality_Lime.Stone_DQ_OakBlend",
  "Stone_DutchQuality_Trim.Stone_DutchQuality_OhioTan_Trim",
  "Stone_DutchQuality_Lime.Stone_DQ_Lime_OhioTan",
  "Stone_DutchQuality_Trim.Stone_DutchQuality_RA_Greystone_Trim",
  "Stone_DutchQuality_RA.Stone_DQ_RA_Greystone",
  "Stone_DutchQuality_Trim.Stone_DutchQuality_RA_Trailhead_Trim",
  "Stone_DutchQuality_RA.Stone_DQ_RA_Trailhead",
  "Stone_DutchQuality_Trim.Stone_DutchQuality_RA_WinterPoint_Trim",
  "Stone_DutchQuality_RA.Stone_DQ_RA_WinterPoint",
  "Stone_MotherEarthStone_Trim.Stone_MES_SEL_GainesboroGrey_Trim",
  "Stone_MotherEarthStone_SEL.Stone_MES_SEL_GainesboroGrey",
  "Stone_MotherEarthStone_Trim.Stone_MES_SEL_GreyBlend_Trim",
  "Stone_MotherEarthStone_SEL.Stone_MES_SEL_GreyBlend",
  "Stone_MotherEarthStone_Trim.Stone_MES_SEL_WestShore_Trim",
  "Stone_MotherEarthStone_SEL.Stone_MES_SEL_WestShore",
  "Stone_MotherEarthStone_Trim.Stone_MES_SS_Ash_Trim",
  "Stone_MotherEarthStone_SS.Stone_MES_SS_Ash",
  "Stone_MotherEarthStone_Trim.Stone_MES_WL_Ash_Trim",
  "Stone_MotherEarthStone_WL.Stone_MES_WL_Ash",
  "Wood_Minwax_Stains_V.Wood_Minwax_Stain_Jacobean_V",
  "Wood_Minwax_Stains.Wood_Minwax_Stain_Jacobean",
  "Stone_Centurion_Ledge.Stone_Centurion_Ledge_Kentucky",
  "IKO.IKO_CornerstoneWW",
  "IKO.IKO_GraniteBlack",
  "Stone_Eldorado_Trim_OLD.Stone_Eldorado_Ashland_Trim",
  "Stone_Eldorado_TB.Stone_Eldorado_TB_Ashland",
  "Stone_Eldorado_Trim_OLD.Stone_Eldorado_BanffSprings_Trim",
  "Stone_Eldorado_CS.Stone_Eldorado_CS_BanffSprings",
  "Stone_Eldorado_Trim_OLD.Stone_Eldorado_Boardwalk_Trim",
  "Stone_Eldorado_CS.Stone_Eldorado_CS_Boardwalk",
  "Stone_Eldorado_Trim_OLD.Stone_Eldorado_ChalkDust_Trim",
  "Stone_Eldorado_TB.Stone_Eldorado_TB_ChalkDust",
  "Stone_Eldorado_Trim_OLD.Stone_Eldorado_Latigo_Trim",
  "Stone_Eldorado_TB.Stone_Eldorado_TB_Latigo",
  "Stone_Eldorado_Trim_OLD.Stone_Eldorado_Montecito_Trim",
  "Stone_Eldorado_CS.Stone_Eldorado_CS_Montecito",
  "Stone_Eldorado_Trim_OLD.Stone_Eldorado_SilverLining_Trim",
  "Stone_Eldorado_SS.Stone_Eldorado_SS_SilverLining",
  "Stone_Eldorado_Trim_OLD.Stone_Eldorado_WhiteBark_Trim",
  "Stone_Eldorado_CS.Stone_Eldorado_WhiteBark",
  "Brick_Harristone.Brick_Harristone_Midnight",
  "Brick_HenryBrick.Brick_HB_Avondale",
  "Brick_Spaulding.Brick_Spaulding_Onslow",
  "CT_Patriot.CT_Patriot_Sablewood",
  "Stone_DutchQuality_Trim.Stone_DQ_DryStack_WinterPoint_Trim",
  "Stone_DutchQuality_DS.Stone_DQ_DS_WinterPoint",
  "Stone_DutchQuality_Trim.Stone_DQ_Weatherledge_CoalCrest_Trim",
  "Stone_DutchQuality_WL.Stone_DQ_WL_CoalCrest",
  "Stone_DutchQuality_Trim.Stone_DQ_Weatherledge_Elkwood_Trim",
  "Stone_DutchQuality_WL.Stone_DQ_WL_Elkwood",
  "Stone_Harristone_Trim.Stone_Harristone_Divino_Huntington_Trim",
  "Stone_Harristone_Div.Stone_Harristone_Divino_Huntington",
  "Stone_Harristone_Trim.Stone_Harristone_Divino_SilverStrand_Trim",
  "Stone_Harristone_Div.Stone_Harristone_Divino_SilverStrand",
  "Stone_Harristone_Trim.Stone_Harristone_Drystone_Highland_Trim",
  "Stone_Harristone_DS.Stone_Harristone_Drystone_Highland",
  "Stone_Harristone_Trim.Stone_Harristone_Drystone_Kingstown_Trim",
  "Stone_Harristone_DS.Stone_Harristone_Drystone_Kingstown",
  "Stone_Harristone_Trim.Stone_Harristone_Drystone_Slate_Trim",
  "Stone_Harristone_DS.Stone_Harristone_Drystone_Slate",
  "Stone_Harristone_Trim.Stone_Harristone_Drystone_Stirling_Trim",
  "Stone_Harristone_DS.Stone_Harristone_Drystone_Stirling",
  "Stone_Harristone_Trim.Stone_Harristone_Leuders_FlintHills_Trim",
  "Stone_Harristone_Leuders.Stone_Harristone_Leuders_FlintHills",
  "Stone_Harristone_Trim.Stone_Harristone_Uintah_Midnight_Trim",
  "Stone_Harristone_Uintah.Stone_Harristone_Uintah_Midnight",
  "Stone_Harristone_Trim.Stone_Harristone_Uintah_RockyCliff_Trim",
  "Stone_Harristone_Uintah.Stone_Harristone_Uintah_RockyCliff",
  null,
  "Stone_StoneCraft_Trim.Stone_StoneCraft_Chardonnay_Trim",
  "Stone_StoneCraft_Trim.Stone_Stonecraft_Hamilton_Trim",
  "Stone_StoneCraft_Ledge.Stone_Stonecraft_Hamilton",
  "Stone_Harristone_Trim.Stone_Harristone_Divino_WhiteSand_Trim",
  "Stone_Harristone_Div.Stone_Harristone_Divino_WhiteSand",
  "Stone_DutchQuality_Trim.Stone_DQ_Limestone_ColumbusBlend_Trim",
  "Stone_DutchQuality_Lime.Stone_DQ_Lime_ColumbusBlend",
  "Stone_DutchQuality_Trim.Stone_DQ_Limestone_Elkwood_Trim",
  "Stone_DutchQuality_Lime.Stone_DQ_Lime_Elkwood",
  "Stone_MotherEarthStone_Trim.Stone_MES_Cob_GreyBlend_Trim",
  "Stone_MotherEarthStone_Cob.Stone_MES_Cob_GreyBlend",
  "Stone_Eldorado_Trim_OLD.Stone_Eldorado_KoryakRidge_Trim",
  "Stone_Eldorado_SS.Stone_Eldorado_SS_KoryakRidge",
  "Stone_Eldorado_Trim_OLD.Stone_Eldorado_NordicPeak_Trim",
  "Stone_Eldorado_CS.Stone_Eldorado_CS_NordicPeak",
  "Stone_DutchQuality_Trim.Stone_DQ_Weatherledge_WinterPoint_Trim",
  "Stone_DutchQuality_WL.Stone_DQ_WL_WinterPoint",
  "Stone_StoneCraft_Trim.Stone_StoneCraft_Bucktown_Trim",
  "Stone_StoneCraft_Ledge.Stone_StoneCraft_Bucktown",
  "Stone_StoneCraft_Trim.Stone_StoneCraft_Pennsylvania_Trim",
  "Stone_StoneCraft_Ledge.Stone_StoneCraft_Pennsylvania",
  "Vinyl_Duradek.Vinyl_Duradek_SupremeSonomaChip",
  "Brick_Columbus.Brick_Columbus_MagnoliaBay",
  "Brick_Columbus.Brick_Columbus_Weracoba2",
  "GAF.GAF_AppalachianSky",
  "GAF.GAF_Shakewood",
  "Stone_Centurion_Trim.Stone_Centurion_Pennsylvania_Trim",
  "Stone_Centurion_Ledge.Stone_Centurion_Ledge_Pennsylvania",
  "Stone_Horizon_Trim.Stone_Horizon_Sedona_Trim",
  "Stone_Horizon_19C.Stone_Horizon_Sedona",
  "Stone_Eldorado_Trim_OLD.Stone_Eldorado_BlackRiver_Trim",
  "Stone_Eldorado_SS.Stone_Eldorado_BlackRiver",
  "Stone_Centurion_Trim.Stone_Centurion_BrownsValley_Trim",
  "Stone_Centurion_Elkmont.Stone_Centurion_Elkmont_BrownsValley",
  "Wood_RMFP.Wood_RMFP_WesternRedCedar",
  "Metal_JetMetals.Metal_JetMetals_Drexlume",
  "Stone_DutchQuality_Trim.Stone_DQ_Arizona_Trim",
  "Stone_DutchQuality_Ledge.Stone_DQ_Arizona",
  "Stone_DutchQuality_Trim.Stone_DQ_Ashen_Trim",
  "Stone_DutchQuality_WL.Stone_DQ_Ashen",
  "Stone_DutchQuality_Trim.Stone_DQ_NaturalBlend_Trim",
  "Stone_DutchQuality_Ledge.Stone_DQ_NaturalBlend",
  "Stone_DutchQuality_Trim.Stone_DQ_Sienna_Trim",
  "Stone_DutchQuality_Ledge.Stone_DQ_Sienna",
  "Wood_ChamClad.Wood_ChamClad_Charwood",
  "Wood_DCM.Wood_DCM_Cedar",
  "Wood_WayneDalton.Wood_WD_Beachwood",
  "Wood_WayneDalton.Wood_WD_Black",
  "Wood_WayneDalton.Wood_WD_CarbonOak",
  "Wood_WayneDalton.Wood_WD_MediumOak",
  "Stone_Eldorado_Trim_OLD.Stone_Eldorado_GrandBanks_Trim",
  "Stone_Eldorado_LS.Stone_Eldorado_LS_GrandBanks",
  "Stone_Eldorado_Trim_OLD.Stone_Eldorado_Hartford_Trim",
  "Stone_Eldorado_TB.Stone_Eldorado_TB_Hartford",
  "Stone_PrestigeStone_Trim.Stone_PS_MoonlitForest_Trim",
  "Stone_QRStone_Trim.Stone_QR_BermudaSand_Trim",
  "Stone_QRStone_CL.Stone_QR_BermudaSand",
  "Stone_QRStone_Trim.Stone_QR_CottageWhite_Trim",
  "Stone_QRStone_RL.Stone_QR_CottageWhite",
  "Stone_QRStone_Trim.Stone_QR_Glacier_Trim",
  "Stone_QRStone_CL.Stone_QR_Glacier",
  "Stone_QRStone_Trim.Stone_QR_Graphite_Trim",
  "Stone_QRStone_RL.Stone_QR_Graphite",
  "Stone_QRStone_Trim.Stone_QR_LakeshoreLinen_Trim",
  "Stone_QRStone_WE.Stone_QR_LakeshoreLinen",
  "Stone_QRStone_Trim.Stone_QR_Midnight_Trim",
  "Stone_QRStone_CL.Stone_QR_Midnight",
  "Stone_QRStone_Trim.Stone_QR_Onyx_Trim",
  "Stone_QRStone_RL.Stone_QR_Onyx",
  "Stone_QRStone_Trim.Stone_QR_Slate_Trim",
  "Stone_QRStone_Cob.Stone_QR_Slate",
  "Stone_QRStone_Trim.Stone_QR_Storm_Trim",
  "Stone_QRStone_RL.Stone_QR_Storm",
  "Stone_QRStone_Trim.Stone_QR_Summit_Trim",
  "Stone_QRStone_DFS.Stone_QR_Summit",
  "Wood_Pella_V.Pella_Wood_Mahogany_V",
  "Wood_Pella.Pella_Wood_Mahogany",
  "Wood_Pella_V.Pella_Wood_Pecan_V",
  "Wood_Pella.Pella_Wood_Pecan",
  "Stone_QRStone_Trim.Stone_QR_SmokeyGray_Trim",
  "Stone_QRStone_Cob.Stone_QR_SmokeyGray",
  "Brick_Binsa.Brick_Binsa_Monroe",
  "Brick_Binsa.Brick_Binsa_Smokey",
  "Brick_Meridian.Brick_Mer_FireOak",
  "Brick_Meridian.Brick_Mer_WhiteHillstone",
  "Brick_Meridian.Brick_Mer_WhiteRiverRock",
  "Stone_RM_Sawn_Trim.Stone_RM_AspenBlendChopped_Trim",
  "Stone_RockMaterials_Sawn.Stone_RM_Sawn_AspenBlendChopped",
  "Stone_RM_Sawn_Trim.Stone_RM_CountryFrenchChopped_Trim",
  "Stone_RockMaterials_Sawn.Stone_RM_Sawn_CountryFrenchChopped",
  "Wood_Minwax_Stains_V.Wood_Minwax_Stain_DarkWalnut_V",
  "Wood_Minwax_Stains.Wood_Minwax_Stain_DarkWalnut",
  "Wood_Minwax_Stains_V.Wood_Minwax_Stain_TrueBlack_V",
  "Wood_Minwax_Stains.Wood_Minwax_Stain_TrueBlack",
  "Wood_SherwinWilliams_Stains_V.Wood_SW_Stain_3023_Flagstone_V",
  "Wood_SherwinWilliams_Stains.Wood_SW_Stain_3023_Flagstone",
  "IKO.IKO_SummitGrey",
  "Brick_USBrick.Brick_US_Twilight",
  "Stone_Centurion_Trim.Stone_Centurion_GrayVillage_Trim",
  "Stone_Centurion_Ledge.Stone_Centurion_Ledge_GrayVillage",
  "Stone_Centurion_Trim.Stone_Centurion_Trim_Limestone",
  "Stone_Centurion_Stack.Stone_Centurion_Limestone",
  "Wood_SherwinWilliams_Stains_V.Wood_SW_Stain_3039_Tobacco_V",
  "Wood_SherwinWilliams_Stains.Wood_SW_Stain_3039_Tobacco",
  "Wood_ChamClad.Wood_ChamClad_ChaiCedar",
  "Brick_Triangle.Brick_Tri_ShadowRidge",
  "Stone_DutchQuality_Trim.Stone_DQ_Prestige_Trim",
  "Stone_DutchQuality_Ledge.Stone_DQ_Prestige",
  "Stone_StoneCreekMidwest_Trim.Stone_SCM_Antique_Trim",
  "Stone_StoneCreekMidwest_SS.Stone_SCM_SS_Antique",
  "Stone_StoneCreekMidwest_Trim.Stone_SCM_Buffalo_Trim",
  "Stone_StoneCreekMidwest_SS.Stone_SCM_SS_Buffalo",
  "Stone_StoneCreekMidwest_Trim.Stone_SCM_Chalk_Trim",
  "Stone_StoneCreekMidwest_SS.Stone_SCM_SS_Chalk",
  "Stone_StoneCreekMidwest_Trim.Stone_SCM_Chardonnay_Trim",
  "Stone_StoneCreekMidwest_SS.Stone_SCM_SS_Chardonnay",
  "Stone_StoneCreekMidwest_Trim.Stone_SCM_DarkGranite_Trim",
  "Stone_StoneCreekMidwest_SS.Stone_SCM_SS_DarkGranite",
  "Stone_StoneCreekMidwest_Trim.Stone_SCM_DirtyChalk_Trim",
  "Stone_StoneCreekMidwest_Hackett.Stone_SCM_Hackett_DirtyChalk",
  "Stone_StoneCreekMidwest_Trim.Stone_SCM_Granite_Trim",
  "Stone_StoneCreekMidwest_LSM.Stone_SCM_Granite",
  "Stone_StoneCreekMidwest_Trim.Stone_SCM_GraniteGJ_Trim",
  "Stone_StoneCreekMidwest_RC.Stone_SCM_RC_GraniteGJ",
  "Stone_StoneCreekMidwest_Trim.Stone_SCM_Greenscapes_Trim",
  "Stone_StoneCreekMidwest_SS.Stone_SCM_SS_Greenscapes",
  "Stone_StoneCreekMidwest_Trim.Stone_SCM_LightGranite_Trim",
  "Stone_StoneCreekMidwest_SS.Stone_SCM_SS_LightGranite",
  "Stone_StoneCreekMidwest_Trim.Stone_SCM_LightOzark_Trim",
  "Stone_StoneCreekMidwest_RC.Stone_SCM_RC_LightOzark",
  "Stone_StoneCreekMidwest_Trim.Stone_SCM_LightOzarkGJ_Trim",
  "Stone_StoneCreekMidwest_RC.Stone_SCM_RC_LightOzarkGJ",
  "Stone_StoneCreekMidwest_Trim.Stone_SCM_Midnight_Trim",
  "Stone_StoneCreekMidwest_SS.Stone_SCM_SS_Midnight",
  "Stone_StoneCreekMidwest_Trim.Stone_SCM_Montana_Trim",
  "Stone_StoneCreekMidwest_SS.Stone_SCM_SS_Montana",
  "Stone_StoneCreekMidwest_Trim.Stone_SCM_MorningHaze_Trim",
  "Stone_StoneCreekMidwest_SS.Stone_SCM_SS_MorningHaze",
  "Stone_StoneCreekMidwest_Trim.Stone_SCM_OldCedarCreek_Trim",
  "Stone_StoneCreekMidwest_SS.Stone_SCM_SS_OldCedarCreek",
  "Stone_StoneCreekMidwest_Trim.Stone_SCM_Ozark_Trim",
  "Stone_StoneCreekMidwest_Hackett.Stone_SCM_Hackett_Ozark",
  "Stone_StoneCreekMidwest_Trim.Stone_SCM_Pennsylvania_Trim",
  "Stone_StoneCreekMidwest_SS.Stone_SCM_SS_Pennsylvania",
  "Stone_StoneCreekMidwest_Trim.Stone_SCM_Sandstorm_Trim",
  "Stone_StoneCreekMidwest_SS.Stone_SCM_SS_Sandstorm",
  "Stone_StoneCreekMidwest_Trim.Stone_SCM_SilveradoGJ_Trim",
  "Stone_StoneCreekMidwest_RC.Stone_SCM_RC_SilveradoGJ",
  "Stone_StoneCreekMidwest_Trim.Stone_SCM_Snow_Trim",
  "Stone_StoneCreekMidwest_RC.Stone_SCM_RC_Snow",
  "Stone_StoneCreekMidwest_Trim.Stone_SCM_SS_Granite_Trim",
  "Stone_StoneCreekMidwest_SS.Stone_SCM_SS_Granite",
  "Stone_StoneCreekMidwest_Trim.Stone_SCM_SS_Ozark_Trim",
  "Stone_StoneCreekMidwest_SS.Stone_SCM_SS_Ozark",
  "Stone_StoneCreekMidwest_Trim.Stone_SCM_Suede_Trim",
  "Stone_StoneCreekMidwest_RC.Stone_SCM_RC_Suede",
  "Stone_StoneCreekMidwest_Trim.Stone_SCM_Texas_Trim",
  "Stone_StoneCreekMidwest_SS.Stone_SCM_SS_Texas",
  "Stone_StoneCreekMidwest_Trim.Stone_SCM_Trinity_Trim",
  "Stone_StoneCreekMidwest_Hackett.Stone_SCM_Hackett_Trinity",
  "Tile_AmericanOlean.Tile_DanyaBasin",
  null,
  null,
  "Brick_GlenGery.Brick_GlenGery_Americano",
  "Brick_GlenGery.Brick_GlenGery_AnthraciteSmooth",
  "Brick_GlenGery.Brick_GlenGery_AspenWhite",
  "Brick_GlenGery.Brick_GlenGery_BaxterBrownSmooth",
  "Brick_GlenGery.Brick_GlenGery_ClassicCreamSmooth",
  "Brick_GlenGery.Brick_GlenGery_RusticGrayWaterstruck",
  "Brick_GeneralShale.Brick_GS_EnglishPub",
  "Brick_GeneralShale.Brick_GS_Ironworks",
  "Brick_GeneralShale.Brick_GS_Peppermill",
  "Stone_BoulderCreek_PB.Stone_BC_PB_DantesPeak",
  "Stone_BoulderCreek_ML.Stone_BC_Jasper",
  "Stone_BoulderCreek_CL.Stone_BC_Loveland",
  "Stone_BoulderCreek_OR.Stone_BC_Stonehenge",
  "Stone_Cultured_SL.Stone_Cultured_SL_BucksCounty",
  "Stone_Eldorado_CCS.Stone_Eldorado_CCS_Seashell",
  "Stone_Eldorado_CRidge.Stone_Eldorado_CRidge_Orchard",
  "Stone_Eldorado_EL.Stone_Eldorado_EL_Zinc",
  "Stone_Eldorado_RC.Stone_Eldorado_RC_FallingSpring",
  "Stone_ProVia_PF.Stone_ProVia_PF_Onyx",
  "Stone_Eldorado_EL.Stone_Eldorado_EL_SeaCliff",
  "Stone_Eldorado_EL.Stone_Eldorado_EL_Sidewalk",
  "Stone_Eldorado_RC.Stone_Eldorado_RC_CasaBlanca",
  "Stone_Eldorado_RC.Stone_Eldorado_RC_LoireValley",
  "Stone_Eldorado_RC.Stone_Eldorado_RC_VineyardTrail",
  "Stone_ProVia_Lime.Stone_ProVia_Lime_Buff",
  "Brick_GeneralShale.Brick_GS_ColonyPointe",
  "Brick_GeneralShale.Brick_GS_CumberlandTudor",
  "Stone_PlyGem_ShadowL.Stone_PlyGem_SL_Buckingham",
  "Stone_PlyGem_ShadowL.Stone_PlyGem_SL_Hampton",
  "Stone_StoneWorks_Ledge.Stone_SW_Ledge_Kentucky",
  "Vinyl_TrafficMaster.VinylStone_NaturalSlateGray",
  "Stone_StoneCreekMidwest_Hackett.Stone_SCM_Granite",
  "Stone_StoneCreekMidwest_RC.Stone_SCM_Granite",
  "Stone_CasaDiSassi_CR.Stone_CDS_Matera",
  "Stone_CasaDiSassi_Volterra.Stone_CDS_Terracina",
  "Stone_Centurion_Ledge.Stone_Centurion_GrayStainless",
  "Stone_Centurion_Ledge.Stone_Centurion_Limestone",
  "Stone_Centurion_Ledge.Stone_Centurion_NorrisGray",
  "Stone_Centurion_Ledge.Stone_Centurion_Texas",
  "Stone_Centurion_Rubble.Stone_Centurion_GrayStainless",
  "Stone_Centurion_Rubble.Stone_Centurion_Limestone",
  "Stone_Centurion_Rubble.Stone_Centurion_NorrisGray",
  "Stone_Centurion_Rubble.Stone_Centurion_Texas",
  "Stone_Cultured_CL.Stone_Cultured_Chardonnay",
  "Stone_Cultured_SL.Stone_Cultured_Chardonnay",
  "Stone_DutchQuality_DS.Stone_DQ_Ashen",
  "Stone_DutchQuality_DS.Stone_DQ_Pennsylvania",
  "Stone_DutchQuality_DS.Stone_DQ_Prestige",
  "Stone_DutchQuality_DS.Stone_DQ_Sienna",
  "Stone_DutchQuality_Lime.Stone_DQ_Pennsylvania",
  "Stone_DutchQuality_SL.Stone_DQ_Sienna",
  "Stone_DutchQuality_SL.Stone_DQ_OakBlend",
  "Stone_DutchQuality_WL.Stone_DQ_Sagewood",
  "Stone_DutchQuality_WL.Stone_DQ_Sienna",
  "Stone_DutchQuality_WL.Stone_DQ_OakBlend",
  "Stone_DutchQuality_WL.Stone_DQ_NaturalBlend",
  "Stone_DutchQuality_WL.Stone_DQ_Pennsylvania",
  "Stone_DutchQuality_WL.Stone_DQ_Prestige",
  "Stone_DutchQuality_WL.Stone_DQ_QuailGrey",
  "Stone_Eldorado_SC.Stone_Eldorado_Monument",
  "Stone_Eldorado_RC.Stone_Eldorado_RC_Moonlight",
  "Stone_MGBrickAndStone_LL.Stone_MGBS_Walnut",
  "Stone_MGBrickAndStone_LSB.Stone_MGBS_Walnut",
  "Stone_MountainView_Hackett.Stone_MV_Appalachian",
  "Stone_MountainView_Ledge.Stone_MV_Tuscany",
  "Stone_PlyGem_CascadeL.Stone_PlyGem_Mystic",
  "Stone_PrestigeStone_SL.Stone_PS_Charcoal",
  "Stone_PrestigeStone_SL.Stone_PS_JacksonCreek",
  "Stone_PrestigeStone_SL.Stone_PS_PortlandMist",
  "Stone_PrestigeStone_SL.Stone_PS_WhiteOnyx",
  "Stone_ProStone_Ledge.Stone_Prostone_Sawgrass",
  "Stone_ProVia_Lime.Stone_ProVia_Flintridge",
  "Stone_ProVia_Lime.Stone_ProVia_Frost",
  "Stone_ProVia_Lime.Stone_ProVia_Slate",
  "Stone_ProVia_Lime.Stone_ProVia_Summit",
  "Stone_StoneWorks_Chisel.Stone_SW_Chisel_Cream",
  "Stone_StoneWorks_Chisel.Stone_SW_CustomEpcon",
  "Stone_StoneWorks_CS.Stone_Env_CS_Kentucky",
  "Stone_StoneWorks_CS.Stone_Env_CS_Texas",
  "Stone_StoneWorks_CS.Stone_Env_Dakota",
  "Stone_StoneWorks_CS.Stone_Env_PASierra",
  "Stone_StoneWorks_CS.Stone_SW_Carolina",
  "Stone_StoneWorks_CS.Stone_SW_Dakota",
  "Stone_StoneWorks_CS.Stone_SW_GreyDrift",
  "Stone_StoneWorks_CS.Stone_SW_PASierra",
  "Stone_StoneWorks_FS.Stone_SW_Dakota",
  "Stone_StoneWorks_FS.Stone_SW_CustomEpcon",
  "Stone_StoneWorks_Grezzo.Stone_SW_Rosa",
  "Stone_StoneWorks_Grezzo.Stone_SW_Grezzo_SabbieNere",
  "Stone_StoneWorks_Grezzo.Stone_SW_CustomEpcon",
  "Stone_StoneWorks_Ledge.Stone_SW_CustomINDakota",
  "Stone_StoneWorks_Ledge.Stone_SW_CustomEpcon",
  "Stone_StoneWorks_Ledge.Stone_SW_Ledge_Breakwater",
  "Stone_StoneWorks_PSL.Stone_SW_PSL_IronSmoke",
  "Stone_StoneWorks_PSL.Stone_SW_GreyDrift",
  "Stone_StoneWorks_PSL.Stone_SW_CustomEpcon",
  "Stone_StoneWorks_Tivoli.Stone_SW_Tivoli_Cream",
  "Stone_StoneWorks_Tivoli.Stone_SW_CustomEpcon",
  "Stone_Eldorado_ML.Stone_Eldorado_ML_GreyDrift",
  "Stone_StoneCreekMidwest_3_5Ledge.Stone_SCM_3_5L_Chalk",
  "Stone_StoneCreekMidwest_3_5Ledge.Stone_SCM_3_5L_DarkGranite",
  "Stone_StoneCreekMidwest_3_5Ledge.Stone_SCM_Trinity",
  "Stone_StoneCreekMidwest_CS.Stone_SCM_CS_MorningHaze",
  "Stone_StoneCreekMidwest_CS.Stone_SCM_Midnight",
  "Stone_StoneCreekMidwest_CS.Stone_SCM_TexasCreme",
  "Stone_StoneCreekMidwest_CS.Stone_SCM_Buffalo",
  "Stone_StoneCreekMidwest_ECastle.Stone_SCM_CustomGranite",
  "Stone_StoneCreekMidwest_ECastle.Stone_SCM_Gray",
  "Stone_StoneCreekMidwest_ECobble.Stone_SCM_ECobble_Granite",
  "Stone_StoneCreekMidwest_ECobble.Stone_SCM_ECobble_LightOzark",
  "Stone_StoneCreekMidwest_ECobble.Stone_SCM_ChalkOG",
  "Stone_StoneCreekMidwest_ECobble.Stone_SCM_OzarkArkansas",
  "Stone_StoneCreekMidwest_FS.Stone_SCM_Natural",
  "Stone_StoneCreekMidwest_FS.Stone_SCM_FS_Arkansas",
  "Stone_StoneCreekMidwest_FS.Stone_SCM_FS_OldCedarCreek",
  "Stone_StoneCreekMidwest_FS.Stone_SCM_FS_Chestnut",
  "Stone_StoneCreekMidwest_FS.Stone_SCM_ValleyBlend",
  "Stone_StoneCreekMidwest_Hackett.Stone_SCM_Arkansas",
  "Stone_StoneCreekMidwest_Hackett.Stone_SCM_NaturalDrystack",
  "Stone_StoneCreekMidwest_Hackett.Stone_SCM_OldCedarCreek",
  "Stone_StoneCreekMidwest_Hackett.Stone_SCM_MountainBreezeGJ",
  "Stone_StoneCreekMidwest_Hackett.Stone_SCM_Hackett_LightGranite",
  "Stone_StoneCreekMidwest_Hackett.Stone_SCM_Chestnut",
  "Stone_StoneCreekMidwest_Hackett.Stone_SCM_Hackett_Chalk",
  "Stone_StoneCreekMidwest_KCB.Stone_SCM_Cherokee",
  "Stone_StoneCreekMidwest_Ledge.Stone_SCM_Texas",
  "Stone_StoneCreekMidwest_Ledge.Stone_SCM_L_Granite",
  "Stone_StoneCreekMidwest_Ledge.Stone_SCM_L_Chardonnay",
  "Stone_StoneCreekMidwest_Lime.Stone_SCM_KansasCream",
  "Stone_StoneCreekMidwest_Lime.Stone_SCM_Lime_BrownArkansas",
  "Stone_StoneCreekMidwest_Lime.Stone_SCM_KansasCreamGJ",
  "Stone_StoneCreekMidwest_Lime.Stone_SCM_ChalkLightOzark",
  "Stone_StoneCreekMidwest_LSM.Stone_SCM_CustomOzark",
  "Stone_StoneCreekMidwest_LSM.Stone_SCM_Desert",
  "Stone_StoneCreekMidwest_LSM.Stone_SCM_BrownArkansas",
  "Stone_StoneCreekMidwest_MR.Stone_SCM_MR_LightGranite",
  "Stone_StoneCreekMidwest_MR.Stone_SCM_CedarCreek",
  "Stone_StoneCreekMidwest_MR.Stone_SCM_MR_Ozark",
  "Stone_StoneCreekMidwest_MWQF.Stone_SCM_Chalk",
  "Stone_StoneCreekMidwest_MWQF.Stone_SCM_MWQF_Slate",
  "Stone_StoneCreekMidwest_MWQF.Stone_SCM_MWQF_MorningHaze",
  "Stone_StoneCreekMidwest_MWQF.Stone_SCM_Sahara",
  "Stone_StoneCreekMidwest_MWQF.Stone_SCM_MWQF_Sandstorm",
  "Stone_StoneCreekMidwest_MWQF.Stone_SCM_HarvestGold",
  "Stone_StoneCreekMidwest_QF.Stone_SCM_QF_Granite",
  "Stone_StoneCreekMidwest_QF.Stone_SCM_QF_Natural",
  "Stone_StoneCreekMidwest_QF.Stone_SCM_QF_Arkansas",
  "Stone_StoneCreekMidwest_QF.Stone_SCM_DirtyChalk",
  "Stone_StoneCreekMidwest_QF.Stone_SCM_QF_Ozark",
  "Stone_StoneCreekMidwest_QF.Stone_SCM_BurntUmber",
  "Stone_StoneCreekMidwest_SL.Stone_SCM_CaramelMountain",
  "Stone_StoneCreekMidwest_StackHackett.Stone_SCM_Arizona",
  "Stone_StoneCreekMidwest_StackHackett.Stone_SCM_Winchester",
  "Stone_StoneCreekMidwest_StackHackett.Stone_SCM_ReverseTexasStone",
  "Stone_StoneCreekMidwest_STL.Stone_SCM_STL_Chalk",
  "Stone_StoneCreekMidwest_STL.Stone_SCM_Sienna",
  "Stone_StoneCreekMidwest_STL.Stone_SCM_BlackForest",
  "Stone_StoneCreekMidwest_TB.Stone_SCM_Dusk",
  "Stone_StoneCreekMidwest_TB.Stone_SCM_Chalk",
  "Stone_StoneCreekMidwest_TB.Stone_SCM_BrickRed",
  "Stone_StoneCreekMidwest_TB.Stone_SCM_TB_Granite",
  "Stone_StoneCreekMidwest_TB.Stone_SCM_TB_LightOzark",
  "Stone_StoneCreekMidwest_TB.Stone_SCM_Schoolhouse",
  "Stone_StoneCreekMidwest_TB.Stone_SCM_Slate",
  "Stone_StoneCreekMidwest_TB.Stone_SCM_Antique",
  "Stone_StoneWorks_FS.Stone_SW_FS_GreyDrift",
  "Brick_Acme.Brick_Acme_StoneLake",
  "Brick_RedRiver.Brick_RedRiver_Madrono",
  "Brick_USBrick.Brick_US_WeatheredWhite",
  "Stone_StoneWorks_CB.Stone_SW_AutumnBlend",
  "Stone_StoneWorks_CB.Stone_SW_Buff",
  "Stone_StoneWorks_CB.Stone_SW_CB_Carillion",
  "Stone_StoneWorks_CB.Stone_SW_CassisModena",
  "Stone_StoneWorks_CB.Stone_SW_Charcoal",
  "Stone_StoneWorks_CB.Stone_SW_Chocolate",
  "Stone_StoneWorks_CB.Stone_SW_Claystone",
  "Stone_StoneWorks_CB.Stone_SW_CB_GreyDrift",
  "Stone_StoneWorks_CB.Stone_SW_CB_Lakeshore",
  "Stone_StoneWorks_CB.Stone_SW_MiamiPearl",
  "Stone_StoneWorks_CB.Stone_SW_Moline",
  "Stone_StoneWorks_CB.Stone_SW_CB_Slate",
  "Stone_StoneWorks_CS.Stone_SW_CS_Dakota",
  "Stone_StoneWorks_CS.Stone_SW_BullRun",
  "Stone_StoneWorks_CS.Stone_SW_Nantucket",
  "Stone_StoneWorks_FS.Stone_SW_LindenWood",
  "Stone_StoneWorks_Grezzo.Stone_SW_Principe",
  "Stone_StoneWorks_Grezzo.Stone_SW_SanDomino",
  "Stone_StoneWorks_Hackett.Stone_SW_Hackett_AndesSummit",
  "Stone_StoneWorks_Hackett.Stone_SW_BlackOak",
  "Stone_StoneWorks_Hackett.Stone_SW_Sandstone",
  "Stone_StoneWorks_Ledge.Stone_SW_Ledge_Appalachian",
  "Stone_StoneWorks_Ledge.Stone_SW_Aspen",
  "Stone_StoneWorks_Ledge.Stone_SW_BucksCounty",
  "Stone_StoneWorks_Ledge.Stone_SW_Champagne",
  "Stone_StoneWorks_Ledge.Stone_SW_Grey",
  "Stone_StoneWorks_Ledge.Stone_SW_MiamiPearl",
  "Stone_StoneWorks_PSL.Stone_SW_BlackRundle",
  "Stone_StoneWorks_PSL.Stone_SW_CedarMesa",
  "Stone_StoneWorks_PSL.Stone_SW_CoolRiver",
  "Stone_StoneWorks_PSL.Stone_SW_EaglesNook",
  "Stone_StoneWorks_PSL.Stone_SW_MiamiPearl",
  "Stone_StoneWorks_PSL.Stone_SW_Monterey",
  "Stone_StoneWorks_PSL.Stone_SW_Saluzzo",
  "Stone_StoneWorks_PSL.Stone_SW_VillaMadero",
  "Stone_StoneWorks_Ripiano.Stone_SW_Eclipse",
  "Stone_StoneWorks_Ripiano.Stone_SW_Mystic",
  "Stone_StoneWorks_Ripiano.Stone_SW_Stardust",
  "Stone_StoneWorks_SL.Stone_SW_Osceola",
  "Stone_StoneWorks_SL.Stone_SW_BucksCounty",
  "Stone_StoneWorks_SL.Stone_SW_Chestnut",
  "Stone_StoneWorks_SL.Stone_SW_Cortona",
  "Stone_StoneWorks_SL.Stone_SW_MesaVerde",
  "Stone_StoneWorks_SL.Stone_SW_Slate",
  "Stone_StoneWorks_Tivoli.Stone_SW_Tivoli_Carillion",
  "Stone_StoneWorks_Tivoli.Stone_SW_Taupe",
  "Stone_StoneWorks_Tivoli.Stone_SW_Tivoli_GunMetal",
  "Stone_StoneWorks_TL.Stone_SW_NickelCreek",
  "Stone_StoneWorks_TL.Stone_SW_WillowPeak",
  "Stone_StoneWorks_TL.Stone_SW_Mist",
  "Stone_StoneWorks_TL.Stone_SW_TL_AndesSummit",
  "Stone_StoneWorks_TL.Stone_SW_EnglishBay",
  "Stone_StoneWorks_TL.Stone_SW_TL_LindenWood",
  "Stone_StoneWorks_WE.Stone_SW_CessnaTan",
  "Stone_StoneWorks_WE.Stone_SW_NewEngland",
  "Stone_StoneWorks_WE.Stone_SW_Northwoods",
  "Stone_StoneWorks_WE.Stone_SW_Silvermine",
  "Stone_StoneWorks_WE.Stone_SW_WE_Slate",
  "Stone_StoneWorks_Chisel.Stone_SW_Chisel_Taupe",
  "Stone_StoneWorks_Luxor.Stone_SW_DesertSunset",
  "Stone_StoneWorks_Luxor.Stone_SW_Luxor_Cream",
  "Stone_StoneWorks_PB.Stone_SW_PB_MiamiPearl",
  "Stone_StoneWorks_TB.Stone_SW_TB_MiamiPearl",
  "Stone_StoneWorks_TB.Stone_SW_Moline",
  "Stone_StoneWorks_TB.Stone_SW_TB_Slate",
  "Stone_StoneWorks_TB.Stone_SW_TB_Lakeshore",
  "Stone_StoneWorks_TB.Stone_SW_TB_GreyDrift",
  "Stone_StoneWorks_TB.Stone_SW_Clove",
  "Stone_StoneWorks_TB.Stone_SW_CassisModena",
  "Stone_StoneWorks_TB.Stone_SW_TB_Buff",
  "Stone_StoneWorks_TB.Stone_SW_TB_AutumnBlend",
  "Brick_Acme.Brick_Acme_Redmont",
  "Brick_Acme.Brick_Acme_SpanishFort",
  "Brick_Columbus.Brick_Columbus_Charleston",
  "Brick_Columbus.Brick_Columbus_Georgetown",
  "Brick_Columbus.Brick_Columbus_OldBailey",
  "Brick_Columbus.Brick_Columbus_Ortega",
  "Brick_Columbus.Brick_Columbus_StoneChase",
  "Brick_Triangle.Brick_Tri_KnobHill",
  "Brick_USBrick.Brick_US_Laredo",
  "CT_Landmark.CT_Landmark_TerraCotta",
  "GAF.GAF_AgedChestnut",
  "GAF.GAF_Birchwood",
  "GAF.GAF_ChestnutValley",
  "GAF.GAF_Cliffside",
  "GAF.GAF_CoastalSlate",
  "GAF.GAF_CopperCanyon",
  "GAF.GAF_GoldenAmber",
  "GAF.GAF_Hickory",
  "GAF.GAF_HunterGreen",
  "GAF.GAF_MidnightMesa",
  "GAF.GAF_Sagewood",
  "GAF.GAF_Sandalwood",
  "GAF.GAF_SierraSand",
  "GAF.GAF_Slate",
  "GAF.GAF_StoneGray",
  "IKO.IKO_AtlanticBlue",
  "IKO.IKO_Biscayne",
  "IKO.IKO_Brownstone",
  "IKO.IKO_DriftShake",
  "IKO.IKO_EmeraldGreen",
  "IKO.IKO_FrostoneGray",
  "IKO.IKO_Glacier",
  "IKO.IKO_MonacoRed",
  "IKO.IKO_OldeStyleWeatherwood",
  "IKO.IKO_SentinelSlate",
  "IKO.IKO_ShadowBrown",
  "Stone_CasaDiSassi_Blend.Stone_CDS_Blend_Cremona",
  "Stone_CasaDiSassi_QL.Stone_CDS_QL_Dente",
  "Stone_CasaDiSassi_VL.Stone_CDS_VL_Ardesia",
  "Stone_CasaDiSassi_Volterra.Stone_CDS_Volterra_Genoa",
  "Stone_Centurion_BrookS.Stone_Centurion_BrookS_Shoreline",
  "Stone_Eldorado_CReef.Stone_Eldorado_CReef_PearlWhite",
  "Stone_Eldorado_CReef.Stone_Eldorado_CReef_Sanibel",
  "Stone_Eldorado_LS.Stone_Eldorado_LS_York",
  "Stone_FondDuLac_Country.Stone_FDL_CharcoalCountry",
  "Stone_FondDuLac_Falls.Stone_FDL_GraphiteFalls",
  "Stone_Halquist_Mosaic.Stone_Halquist_Mosaic_AshfordBlend",
  "Stone_Halquist_Mosaic.Stone_Halquist_Mosaic_KohlerBuff",
  "Stone_Halquist_Mosaic.Stone_Halquist_Mosaic_KohlerFullColor",
  "Stone_Halquist_Ledge.Stone_Halquist_Ledge_BasswoodBuff",
  "Stone_Halquist_Ledge.Stone_Halquist_Ledge_BrookfieldBuff",
  "Stone_Lurveys_Falls.Stone_Lurveys_GraphiteFalls",
  "Stone_PrestigeStone_FS.Stone_PS_FS_Acadia",
  "Stone_PrestigeStone_MD.Stone_PS_MD_WhiteOnyx",
  "Stone_PrestigeStone_WL.Stone_PS_WL_PortlandDusk",
  "Stone_PrestigeStone_WL.Stone_PS_WL_Winona",
  "Stone_ProVia_Ledge.Stone_ProVia_Ledge_Mystic",
  "Stone_ProVia_Ledge.Stone_ProVia_Ledge_Oxford",
  "Stone_ProVia_Ledge.Stone_ProVia_Ledge_Southbriar",
  "Stone_ProVia_TC.Stone_ProVia_Niagara",
  "Tamko.Tamko_BlackWalnut",
  "Tamko.Tamko_RusticBrown",
  "Wood_Minwax_Stains.Wood_Minwax_Stain_Ebony2718",
  "Wood_Minwax_Stains.Wood_Minwax_Stain_Forrester421",
  "Wood_Minwax_Stains.Wood_Minwax_Stain_Navy471",
  "Wood_Minwax_Stains.Wood_Minwax_Stain_TidalWood415",
  "Wood_Minwax_Stains.Wood_Minwax_Stain_Willowbend431",
  "Stone_Centurion_Ashlar.Stone_Centurion_Ashlar_BucksCounty",
  "Stone_Centurion_Ashlar.Stone_Centurion_Ashlar_OdessaFalls",
  "Stone_Centurion_Ashlar.Stone_Centurion_Ashlar_Pennsylvania",
  "Stone_Centurion_Biltmore.Stone_Centurion_Biltmore_Pennsylvania",
  "Stone_Centurion_Biltmore.Stone_Centurion_Biltmore_Smoke",
  "Stone_Centurion_Biltmore.Stone_Centurion_Biltmore_Texas",
  "Stone_Centurion_BrickS.Stone_Centurion_BrickS_Lexington",
  "Stone_Centurion_BrickS.Stone_Centurion_BrickS_Midnight",
  "Stone_Centurion_BrickS.Stone_Centurion_BrickS_Mist",
  "Stone_Centurion_BrookS.Stone_Centurion_BrookS_Cream",
  "Stone_Centurion_BrookS.Stone_Centurion_BrookS_Heather",
  "Stone_Centurion_BrookS.Stone_Centurion_BrookS_Rocky",
  "Stone_Centurion_CathedralS.Stone_Centurion_CathedralS_Alpine",
  "Stone_Centurion_CathedralS.Stone_Centurion_CathedralS_Plain",
  "Stone_Centurion_CathedralS.Stone_Centurion_CathedralS_SageValley",
  "Stone_Centurion_CB.Stone_Centurion_CB_BucksCounty",
  "Stone_Centurion_CB.Stone_Centurion_CB_Pennsylvania",
  "Stone_Centurion_CB.Stone_Centurion_CB_Suede",
  "Stone_Centurion_CC.Stone_Centurion_CC_BucksCounty",
  "Stone_Centurion_CC.Stone_Centurion_CC_California",
  "Stone_Centurion_CC.Stone_Centurion_CC_Gray",
  "Stone_Centurion_CC.Stone_Centurion_CC_Pennsylvania",
  "Stone_Centurion_CC.Stone_Centurion_CC_Suede",
  "Stone_Centurion_CF.Stone_Centurion_CF_Arizona",
  "Stone_Centurion_CF.Stone_Centurion_CF_Brown",
  "Stone_Centurion_CF.Stone_Centurion_CF_Kentucky",
  "Stone_Centurion_CF.Stone_Centurion_CF_Louisville",
  "Stone_Centurion_CF.Stone_Centurion_CF_MountainRundle",
  "Stone_Centurion_CF.Stone_Centurion_CF_Pennsylvania",
  "Stone_Centurion_CF.Stone_Centurion_CF_Suede",
  "Stone_Centurion_CL.Stone_Centurion_CL_BrownsValley",
  "Stone_Centurion_CL.Stone_Centurion_CL_SouthernWheat",
  "Stone_Centurion_Design.Stone_Centurion_Design_Austin",
  "Stone_Centurion_Design.Stone_Centurion_Design_Chardonnay",
  "Stone_Centurion_Design.Stone_Centurion_Design_Coastal",
  "Stone_Centurion_Design.Stone_Centurion_Design_Kentucky",
  "Stone_Centurion_Design.Stone_Centurion_Design_MesaValley",
  "Stone_Centurion_Design.Stone_Centurion_Design_MountainRundle",
  "Stone_Centurion_Elkmont.Stone_Centurion_Elkmont_Kentucky",
  "Stone_Centurion_Foundation.Stone_Centurion_Foundation_Crimson",
  "Stone_Centurion_Foundation.Stone_Centurion_Foundation_Plain",
  "Stone_Centurion_FS.Stone_Centurion_FS_Plain",
  "Stone_Centurion_FS.Stone_Centurion_FS_Kentucky",
  "Stone_Centurion_Georgetown.Stone_Centurion_Georgetown_Smoke",
  "Stone_Centurion_Georgetown.Stone_Centurion_Georgetown_Kentucky",
  "Stone_Centurion_Hackett.Stone_Centurion_Hackett_Austin",
  "Stone_Centurion_Hackett.Stone_Centurion_Hackett_English",
  "Stone_Centurion_Ledge.Stone_Centurion_Ledge_Louisville",
  "Stone_Centurion_Ledge.Stone_Centurion_Ledge_Brown",
  "Stone_Centurion_Ledge.Stone_Centurion_Ledge_BucksCounty",
  "Stone_Centurion_Mesa.Stone_Centurion_Mesa_Appalachian",
  "Stone_Centurion_ML.Stone_Centurion_ML_Austin",
  "Stone_Centurion_ML.Stone_Centurion_ML_BucksCounty",
  "Stone_Centurion_ML.Stone_Centurion_ML_Kentucky",
  "Stone_Centurion_ML.Stone_Centurion_ML_Oxford",
  "Stone_Centurion_OLS.Stone_Centurion_OLS_BrownsValley",
  "Stone_Centurion_OLS.Stone_Centurion_OLS_Millwood",
  "Stone_Centurion_OLS.Stone_Centurion_OLS_Texas",
  "Stone_Centurion_OLS.Stone_Centurion_OLS_Tulsa",
  "Stone_Centurion_PV.Stone_Centurion_PV_Summit",
  "Stone_Centurion_PV.Stone_Centurion_PV_Kentucky",
  "Stone_Centurion_PV.Stone_Centurion_PV_Pennsylvania",
  "Stone_Centurion_QS.Stone_Centurion_QS_BellHarbor",
  "Stone_Centurion_RR.Stone_Centurion_RR_BrownsValley",
  "Stone_Centurion_RR.Stone_Centurion_RR_DesertRust",
  "Stone_Centurion_RR.Stone_Centurion_RR_ValleyBrook",
  "Stone_Centurion_Rubble.Stone_Centurion_Rubble_BucksCounty",
  "Stone_Centurion_Rubble.Stone_Centurion_Rubble_Suede",
  "Stone_Centurion_Rubble.Stone_Centurion_Rubble_Pennsylvania",
  "Stone_Centurion_Rubble.Stone_Centurion_Rubble_Plain",
  "Stone_Centurion_Rubble.Stone_Centurion_Rubble_Kentucky",
  "Stone_Centurion_Rustic.Stone_Centurion_Rustic_Gray",
  "Stone_Centurion_Rustic.Stone_Centurion_Rustic_Pennsylvania",
  "Stone_Centurion_Rustic.Stone_Centurion_Rustic_Kentucky",
  "Stone_Centurion_Rustic.Stone_Centurion_Rustic_Arizona",
  "Stone_Centurion_Rustic.Stone_Centurion_Rustic_Brown",
  "Stone_Centurion_SF.Stone_Centurion_SF_NewEngland",
  "Stone_Centurion_SF.Stone_Centurion_SF_Pennsylvania",
  "Stone_Centurion_SF.Stone_Centurion_SF_Texas",
  "Stone_Centurion_SL.Stone_Centurion_SL_Catalina",
  "Stone_Centurion_SL.Stone_Centurion_SL_Suede",
  "Stone_Centurion_Stack.Stone_Centurion_Stack_Kentucky",
  "Stone_Centurion_Stack.Stone_Centurion_Stack_Chardonnay",
  "Stone_Centurion_Stack.Stone_Centurion_Stack_Arizona",
  "Stone_Centurion_Stack.Stone_Centurion_Stack_Pennsylvania",
  "Stone_Centurion_Stack.Stone_Centurion_Stack_BucksCounty",
  "Stone_Centurion_Topeka.Stone_Centurion_Topeka_Santos",
  "Stone_Centurion_WE.Stone_Centurion_WE_Brown",
  "Stone_Centurion_WE.Stone_Centurion_WE_Kentucky",
  "Stone_Eldorado_BS.Stone_Eldorado_BS_Bodega",
  "Stone_Eldorado_BS.Stone_Eldorado_BS_Mineret",
  "Stone_Eldorado_CA.Stone_Eldorado_CA_Carmela",
  "Stone_Eldorado_CA.Stone_Eldorado_CA_Bautista",
  "Stone_Eldorado_CCS.Stone_Eldorado_CCS_Cannonade",
  "Stone_Eldorado_CCS.Stone_Eldorado_CCS_Madrona",
  "Stone_Eldorado_CCS.Stone_Eldorado_CCS_Oyster",
  "Stone_Eldorado_CRidge.Stone_Eldorado_CRidge_Catania",
  "Stone_Eldorado_CRubble.Stone_Eldorado_CRubble_Cognac",
  "Stone_Eldorado_CRubble.Stone_Eldorado_CRubble_Bella",
  "Stone_Eldorado_CRubble.Stone_Eldorado_CRubble_Millstream",
  "Stone_Eldorado_CRubble.Stone_Eldorado_CRubble_Polermo",
  "Stone_Eldorado_CS.Stone_Eldorado_CS_Barley",
  "Stone_Eldorado_CS.Stone_Eldorado_CS_Cambria",
  "Stone_Eldorado_CS.Stone_Eldorado_CS_Lantana",
  "Stone_Eldorado_CS.Stone_Eldorado_CS_Manzanita",
  "Stone_Eldorado_CS.Stone_Eldorado_CS_Mesquite",
  "Stone_Eldorado_EL.Stone_Eldorado_EL_Cottonwood",
  "Stone_Eldorado_EL.Stone_Eldorado_EL_Glacier",
  "Stone_Eldorado_EL.Stone_Eldorado_EL_Linen",
  "Stone_Eldorado_FL.Stone_Eldorado_FL_Meseta",
  "Stone_Eldorado_FL.Stone_Eldorado_FL_Padova",
  "Stone_Eldorado_FL.Stone_Eldorado_FL_RanchersRidge",
  "Stone_Eldorado_FL.Stone_Eldorado_FL_Veneto",
  "Stone_Eldorado_LB.Stone_Eldorado_LB_Farola",
  "Stone_Eldorado_LB.Stone_Eldorado_LB_Hollin",
  "Stone_Eldorado_LB.Stone_Eldorado_LB_Lilia",
  "Stone_Eldorado_LB.Stone_Eldorado_LB_Talavera",
  "Stone_Eldorado_LC.Stone_Eldorado_LC_BeachPebble",
  "Stone_Eldorado_LC.Stone_Eldorado_LC_Birch",
  "Stone_Eldorado_LC.Stone_Eldorado_LC_OceanFloor",
  "Stone_Eldorado_LC.Stone_Eldorado_LC_Sage",
  "Stone_Eldorado_LC.Stone_Eldorado_LC_Whitecap",
  "Stone_Eldorado_LS.Stone_Eldorado_LS_NewHaven",
  "Stone_Eldorado_LS.Stone_Eldorado_LS_SanMarino",
  "Stone_Eldorado_LS.Stone_Eldorado_LS_Shilo",
  "Stone_Eldorado_Marquee.Stone_Eldorado_Marquee_DoveTail",
  "Stone_Eldorado_Marquee.Stone_Eldorado_Marquee_Sanderling",
  "Stone_Eldorado_ML.Stone_Eldorado_ML_Asheville",
  "Stone_Eldorado_ML.Stone_Eldorado_ML_Charleston",
  "Stone_Eldorado_ML.Stone_Eldorado_ML_Durango",
  "Stone_Eldorado_ML.Stone_Eldorado_ML_Lexington",
  "Stone_Eldorado_ML.Stone_Eldorado_ML_Yukon",
  "Stone_Eldorado_MLP.Stone_Eldorado_MLP_BowValley",
  "Stone_Eldorado_MLP.Stone_Eldorado_MLP_Pioneer",
  "Stone_Eldorado_MLP.Stone_Eldorado_MLP_Russet",
  "Stone_Eldorado_MLP.Stone_Eldorado_MLP_Silverton",
  "Stone_Eldorado_MLP.Stone_Eldorado_MLP_WhiskeyCreek",
  "Stone_Eldorado_RC.Stone_Eldorado_RC_RanchersRidge",
  "Stone_Eldorado_RC.Stone_Eldorado_RC_Wheatfield",
  "Stone_Eldorado_RL.Stone_Eldorado_RL_Cascade",
  "Stone_Eldorado_RL.Stone_Eldorado_RL_Sawtooth",
  "Stone_Eldorado_RL.Stone_Eldorado_RL_Sequoia",
  "Stone_Eldorado_RR.Stone_Eldorado_RR_Colorado",
  "Stone_Eldorado_RR.Stone_Eldorado_RR_RioGrande",
  "Stone_Eldorado_RR.Stone_Eldorado_RR_Yakima",
  "Stone_Eldorado_RT.Stone_Eldorado_RT_GraniteSpire",
  "Stone_Eldorado_SR.Stone_Eldorado_SR_Bronze",
  "Stone_Eldorado_SR.Stone_Eldorado_SR_Chesapeake",
  "Stone_Eldorado_SR.Stone_Eldorado_SR_CrescentPeak",
  "Stone_Eldorado_SR.Stone_Eldorado_SR_Somerset",
  "Stone_Eldorado_SR.Stone_Eldorado_SR_Teton",
  "Stone_Eldorado_SR.Stone_Eldorado_SR_Willow",
  "Stone_Eldorado_SS.Stone_Eldorado_SS_Alderwood",
  "Stone_Eldorado_SS.Stone_Eldorado_SS_Castaway",
  "Stone_Eldorado_SS.Stone_Eldorado_SS_DarkRundle",
  "Stone_Eldorado_SS.Stone_Eldorado_SS_Daybreak",
  "Stone_Eldorado_SS.Stone_Eldorado_SS_DryCreek",
  "Stone_Eldorado_SS.Stone_Eldorado_SS_SlateGray",
  "Stone_Eldorado_TB.Stone_Eldorado_TB_Riverbed",
  "Stone_Eldorado_Vantage.Stone_Eldorado_Vantage_Cumulus",
  "Stone_Eldorado_Vantage.Stone_Eldorado_Vantage_SouthernPeak",
  "Stone_Eldorado_Vantage.Stone_Eldorado_Vantage_Stormcloud",
  "Stone_Eldorado_Vantage.Stone_Eldorado_Vantage_WhiteElm",
  "Stone_Eldorado_Zen.Stone_Eldorado_Zen_Nickel",
  "Stone_Eldorado_Zen.Stone_Eldorado_Zen_SoftLight",
  "Stone_PlyGem_CanyonL.Stone_PlyGem_CanL_Chardonnay",
  "Stone_PlyGem_CanyonL.Stone_PlyGem_CanL_Hampton",
  "Stone_PlyGem_CanyonL.Stone_PlyGem_CanL_Niagara",
  "Stone_PlyGem_CanyonL.Stone_PlyGem_CanL_MidnightSlate",
  "Stone_PlyGem_CanyonL.Stone_PlyGem_CanL_Summit",
  "Stone_PlyGem_CanyonL.Stone_PlyGem_CanL_Winfield",
  "Stone_PlyGem_CascadeL.Stone_PlyGem_CasL_AlpineMist",
  "Stone_PlyGem_CC.Stone_PlyGem_CC_Aberdeen",
  "Stone_PlyGem_CC.Stone_PlyGem_CC_Autumn",
  "Stone_PlyGem_CC.Stone_PlyGem_CC_Buckingham",
  "Stone_PlyGem_CC.Stone_PlyGem_CC_Chardonnay",
  "Stone_PlyGem_CC.Stone_PlyGem_CC_Hampton",
  "Stone_PlyGem_CC.Stone_PlyGem_CC_PALime",
  "Stone_PlyGem_CC.Stone_PlyGem_CC_ShadeMountain",
  "Stone_PlyGem_CC.Stone_PlyGem_CC_Winfield",
  "Stone_PlyGem_FS.Stone_PlyGem_FS_Autumn",
  "Stone_PlyGem_FS.Stone_PlyGem_FS_Buckingham",
  "Stone_PlyGem_FS.Stone_PlyGem_FS_Chardonnay",
  "Stone_PlyGem_FS.Stone_PlyGem_FS_PALime",
  "Stone_PlyGem_FS.Stone_PlyGem_FS_ShadeMountain",
  "Stone_PlyGem_Manorstone.Stone_PlyGem_MS_Summit",
  "Stone_PlyGem_ShadowL.Stone_PlyGem_SL_Autumn",
  "Stone_PlyGem_ShadowL.Stone_PlyGem_SL_Bradford",
  "Stone_PlyGem_ShadowL.Stone_PlyGem_SL_Chardonnay",
  "Stone_PlyGem_ShadowL.Stone_PlyGem_SL_Shenandoah",
  "Stone_PlyGem_CanyonL.Stone_PlyGem_CanL_Mystic",
  "Stone_PlyGem_ShadowL.Stone_PlyGem_SL_Niagara",
  "Stone_PlyGem_ShadowL.Stone_PlyGem_SL_PALime",
  "Stone_PlyGem_ShadowL.Stone_PlyGem_SL_ShadeMountain",
  "Stone_ProVia_CC.Stone_ProVia_CC_Olympus",
  "Stone_ProVia_CC.Stone_ProVia_CC_Sterling",
  "Stone_ProVia_CC.Stone_ProVia_CC_Wellington",
  "Stone_ProVia_DS.Stone_ProVia_DS_Catawba",
  "Stone_ProVia_DS.Stone_ProVia_DS_Chestnut",
  "Stone_ProVia_DS.Stone_ProVia_DS_Huron",
  "Stone_ProVia_DS.Stone_ProVia_DS_Shawnee",
  "Stone_ProVia_DS.Stone_ProVia_DS_Southport",
  "Stone_ProVia_DS.Stone_ProVia_DS_Toccoa",
  "Stone_ProVia_DS.Stone_ProVia_DS_Whisperwood",
  "Stone_ProVia_EC.Stone_ProVia_EC_Admiral",
  "Stone_ProVia_EC.Stone_ProVia_EC_Beech",
  "Stone_ProVia_EC.Stone_ProVia_EC_Obsidian",
  "Stone_ProVia_EC.Stone_ProVia_EC_Polar",
  "Stone_ProVia_FS.Stone_ProVia_FS_Breckenridge",
  "Stone_ProVia_FS.Stone_ProVia_FS_OldDominion",
  "Stone_ProVia_FS.Stone_ProVia_FS_Pennsylvania",
  "Stone_ProVia_FS.Stone_ProVia_FS_Shenandoah",
  "Stone_ProVia_FS.Stone_ProVia_FS_Strathmore",
  "Stone_ProVia_FS.Stone_ProVia_FS_TopRock",
  "Stone_ProVia_Ledge.Stone_ProVia_Ledge_Brighton",
  "Stone_ProVia_Ledge.Stone_ProVia_Ledge_Santee",
  "Stone_ProVia_Ledge.Stone_ProVia_Ledge_Susquehanna",
  "Stone_ProVia_Lime.Stone_ProVia_Lime_Buckingham",
  "Stone_ProVia_Lime.Stone_ProVia_Lime_Harbor",
  "Stone_ProVia_Lime.Stone_ProVia_Lime_OhioVintage",
  "Stone_ProVia_Lime.Stone_ProVia_Lime_Vail",
  "Stone_ProVia_NC.Stone_ProVia_NC_Alta",
  "Stone_ProVia_NC.Stone_ProVia_NC_Fernwood",
  "Stone_ProVia_NC.Stone_ProVia_NC_Seaboard",
  "Stone_ProVia_NC.Stone_ProVia_NC_Woodbridge",
  "Stone_ProVia_PF.Stone_ProVia_PF_Alpine",
  "Stone_ProVia_PF.Stone_ProVia_PF_Arctic",
  "Stone_ProVia_PF.Stone_ProVia_PF_SageGray",
  "Stone_ProVia_RC.Stone_ProVia_RC_CastleRock",
  "Stone_ProVia_RC.Stone_ProVia_RC_Denali",
  "Stone_ProVia_RC.Stone_ProVia_RC_Yosemite",
  "Stone_ProVia_RR.Stone_ProVia_RR_Michigan",
  "Stone_ProVia_RR.Stone_ProVia_RR_Mountain",
  "Stone_ProVia_TB.Stone_ProVia_TB_Boston",
  "Stone_ProVia_TB.Stone_ProVia_TB_Cobblestone",
  "Stone_ProVia_TB.Stone_ProVia_TB_Delaware",
  "Stone_ProVia_TB.Stone_ProVia_TB_Independence",
  "Stone_ProVia_TB.Stone_ProVia_TB_Midnight",
  "Stone_ProVia_TB.Stone_ProVia_TB_Yorktown",
  "Stone_ProVia_TC.Stone_ProVia_TC_Acadia",
  "Stone_ProVia_TC.Stone_ProVia_TC_Graphite",
  "Stone_ProVia_TC.Stone_ProVia_TC_Niagara",
  "Stone_ProVia_TC.Stone_ProVia_TC_Palisade",
  "Stone_ProVia_TC.Stone_ProVia_TC_Rainier",
  "Stone_ProVia_TC.Stone_ProVia_TC_Wellington",
  "Stone_ProVia_TC.Stone_ProVia_TC_Yuma",
  "Brick_Acme.Brick_Acme_CiboloTrail",
  "Brick_Acme.Brick_Acme_CopperasCove",
  "Brick_Acme.Brick_Acme_OxfordPlace",
  "Brick_Claymex.Brick_Claymex_UrbanaAntique",
  "Brick_CommercialBrickCompany.Brick_CBC_CommercialAntique",
  "Brick_Master.Brick_Master_Chateau",
  "Brick_Master.Brick_Master_PortEdwards",
  "Brick_RedRiver.Brick_RedRiver_SteelManor",
  "Brick_RedRiver.Brick_RedRiver_SummerAsh",
  "Brick_Acme.Brick_Acme_WhiteBirch",
  "Stone_Legends_BA.Stone_Legends_EdinburghBlend",
  "Stone_Legends_BC.Stone_Legends_PoconosBlend",
  "Stone_Legends_BC.Stone_Legends_WexfordBlend",
  "Stone_Legends_Ledge.Stone_Legends_AshlandGray",
  "Stone_Legends_Ledge.Stone_Legends_BrazosCanyon",
  "Stone_Legends_Ledge.Stone_Legends_Castlebridge",
  "Stone_RockMaterials_Ledge.Stone_RM_BlancoLedgestone",
  "Stone_RockMaterials_Sawn.Stone_RM_BluebonnetChop",
];
